/* Calculadora de materiales Osco · interfaz web 2026
   Las fórmulas y productos vienen de OSCO_Calculadora.html (Johanna Corporán).
   PARA ACTUALIZAR PRODUCTOS: reemplaza solo lo que está entre INICIO DATOS y FIN DATOS.
   PARA CAMBIAR LOS COMPLEMENTOS: edita el bloque INICIO COMPLEMENTOS / FIN COMPLEMENTOS. */
(function(){
'use strict';

/* ======== INICIO DATOS (copiado de OSCO_Calculadora.html) ======== */
const dosingTable = [
  // 350: estimado con método ACI 211.1 (relación a/c ≈ 0.395 con sobrediseño; agua 202 kg/m³) ≈ 510 kg/m³.
  // No viene de la tabla original del Excel: verificar con datos reales de concreteras.
  { resistencia: 350, cemento: 510 },
  { resistencia: 280, cemento: 420 },
  { resistencia: 240, cemento: 380 },
  { resistencia: 226, cemento: 350 },
  { resistencia: 210, cemento: 320 },
  { resistencia: 200, cemento: 300 },
  { resistencia: 189, cemento: 280 },
  { resistencia: 168, cemento: 300 },
  { resistencia: 159, cemento: 260 },
  { resistencia: 140, cemento: 230 },
  { resistencia: 119, cemento: 210 },
  { resistencia: 109, cemento: 175 },
  { resistencia: 99,  cemento: 160 },
];

/* =========================================================
   DEFINICIÓN DE PARÁMETROS COMPARTIDOS
   ========================================================= */
const PARAM_DEFS = {
  volumen: {
    label: 'Volumen de concreto del proyecto',
    type: 'number',
    suffix: 'm³',
    default: 15
  },
  resistencia: {
    label: 'Resistencia de diseño',
    type: 'select',
    options: dosingTable.map(r => ({ value: r.resistencia, label: r.resistencia + ' kg/cm² · ' + r.cemento + ' kg cemento/m³' })),
    default: 280
  },
  fundasCemento: {
    label: 'Número de fundas de cemento (50 kg)',
    type: 'number',
    suffix: 'fundas',
    default: 5
  },
  longitudJunta: {
    label: 'Longitud de la junta',
    type: 'number',
    suffix: 'm',
    default: 50
  },
  anchoJunta: {
    label: 'Ancho de la junta',
    type: 'number',
    suffix: 'mm',
    default: 12
  },
  profundidadJunta: {
    label: 'Profundidad de la junta',
    type: 'number',
    suffix: 'mm',
    default: 25
  },
  dosisMacrofibra: {
    label: 'Dosis de macrofibra confirmada para el proyecto',
    type: 'number',
    suffix: 'kg/m³',
    default: 3.5,
    hint: 'Referencia de ficha: 2–5 kg/m³ (3.5 = punto medio, solo para estimar). Usa la dosis que confirme Polyfibers para el proyecto.'
  },
  areaLosa: {
    label: 'Área de la losa o calle',
    type: 'number',
    suffix: 'm²',
    default: 100
  },
  espesorLosa: {
    label: 'Espesor de la losa',
    type: 'number',
    suffix: 'cm',
    default: 15
  },
  area: {
    label: 'Área total del piso a tratar',
    type: 'number',
    suffix: 'm²',
    default: 100
  },
  espesorSelfing: {
    label: 'Espesor Selfing 600 (mín. 3, máx. 10)',
    type: 'number',
    suffix: 'mm',
    default: 5
  },
  espesorEpoxSL800: {
    label: 'Espesor Epox SL 800 (estándar = 1)',
    type: 'number',
    suffix: 'mm',
    default: 1
  },
  pctDanos: {
    label: '% del área con daños estructurales',
    type: 'number',
    suffix: '%',
    default: 15
  }
};

/* ---------------------------------------------------------
   Parámetros por uso: Reparaciones y Reforzamientos Estructurales
   Cada producto tiene sus propias claves (área, espesor, anclajes...)
   para que, en "varios productos", la geometría de una reparación
   no se mezcle con la de otra.
   --------------------------------------------------------- */
PARAM_DEFS.margen = {
  label: 'Margen por desperdicio',
  type: 'number', suffix: '%', default: 10,
  hint: 'Merma típica de obra (igual que en el cotizador de piso epóxico). Pon 0 para ver la cantidad exacta de la ficha.'
};
[
  ['Grt20', 'GRT 20', 20], ['Epox305', 'Epox 305', 3], ['Epox310', 'Epox 310', 20], ['G1107', '1107 Advantage', 40]
].forEach(([k, tag, esp]) => {
  PARAM_DEFS['area' + k]    = { label: `Área a tratar (${tag})`,        type: 'number', suffix: 'm²', default: 2 };
  PARAM_DEFS['espesor' + k] = { label: `Espesor de aplicación (${tag})`, type: 'number', suffix: 'mm', default: esp };
});
// Anclajes (pernos, varillas, espárragos): geometría del orificio
[['Grt20', 'GRT 20'], ['Epox305', 'Epox 305'], ['G1107', '1107 Advantage']].forEach(([k, tag]) => {
  PARAM_DEFS['n' + k]    = { label: `Número de anclajes (${tag})`,            type: 'number', suffix: 'unid.', default: 10 };
  PARAM_DEFS['dOr' + k]  = { label: `Diámetro del orificio (${tag})`,         type: 'number', suffix: 'mm', default: 20 };
  PARAM_DEFS['dVar' + k] = { label: `Diámetro de la varilla o perno (${tag})`, type: 'number', suffix: 'mm', default: 16 };
  PARAM_DEFS['prof' + k] = { label: `Profundidad de anclaje (${tag})`,        type: 'number', suffix: 'mm', default: 150 };
});
PARAM_DEFS.volLGrt20 = { label: 'Volumen a rellenar (GRT 20)', type: 'number', suffix: 'L', default: 20 };
PARAM_DEFS.longEpox310  = { label: 'Longitud de la junta o grieta (Epox 310)',    type: 'number', suffix: 'm',  default: 10 };
PARAM_DEFS.anchoEpox310 = { label: 'Ancho de la junta o grieta (Epox 310)',       type: 'number', suffix: 'mm', default: 10 };
PARAM_DEFS.profEpox310  = { label: 'Profundidad de la junta o grieta (Epox 310)', type: 'number', suffix: 'mm', default: 25 };
PARAM_DEFS.kgWatershock = {
  label: 'Cantidad estimada de Watershock', type: 'number', suffix: 'kg', default: 5,
  hint: 'La ficha indica consumo variable (depende del tamaño y la profundidad de la zona). Estímalo con el asesor.'
};

// Volumen (litros) de mortero para llenar anclajes: corona anular entre orificio y varilla
function volAnclajesL(inputs, k){
  const n = parseFloat(inputs['n' + k] || 0), dh = parseFloat(inputs['dOr' + k] || 0);
  const db = parseFloat(inputs['dVar' + k] || 0), prof = parseFloat(inputs['prof' + k] || 0);
  if (!(dh > db)) return { L: 0, bad: true };
  return { L: n * Math.PI / 4 * (dh * dh - db * db) * prof / 1e6, bad: false };   // mm³ → L
}
// Cantidad con margen: neto (al empaque) y a comprar (margen incluido, redondeo hacia arriba)
function conMargen(kg, pkgKg, inputs){
  const m = Math.max(parseFloat(inputs.margen || 0), 0) / 100;
  return { kg, netUnits: ceilTo(kg / pkgKg), units: ceilTo(kg * (1 + m) / pkgKg), margenPct: m * 100, needKg: kg * (1 + m) };
}
const warnTxt = t => `<br><b style="color:#FF6900;">⚠ ${t}</b>`;
// Cotizador de piso epóxico (Excel original): redondeo al empaque y luego +10% con segundo redondeo
function conMargenExcel(kg, pkgKg){
  const net = ceilTo(kg / pkgKg);
  const units = ceilTo(net * 1.1);
  return { kg, netUnits: net, units, margenPct: 10, needKg: units * pkgKg };
}
// SBR Látex 35-40: 1.08 kg/L × 18.927 L (5 galones) ≈ 20.44 kg por cubeta
const SBR_PKG_KG = 5 * 3.78541 * 1.08;
const SBR_KG_POR_GAL = 3.78541 * 1.08;

PARAM_DEFS.areaLona  = { label: 'Área a impermeabilizar con lona', type: 'number', suffix: 'm²', default: 100 };
PARAM_DEFS.capasLona = {
  label: 'Número de capas', type: 'number', suffix: 'capa(s)', default: 1,
  hint: '1 = monocapa · 2 = doble capa (multicapa). El rendimiento del rollo es por capa.'
};
PARAM_DEFS.areaTecho = { label: 'Área del techo o superficie a cubrir', type: 'number', suffix: 'm²', default: 100 };
PARAM_DEFS.galCemento100 = {
  label: 'Galones de cemento plástico por cada 100 m²', type: 'number', suffix: 'gal / 100 m²', default: 1,
  hint: 'Regla general de OSCO: 1 galón por cada 100 m². Súbela si el techo tiene muchas ventilas, tubos, bajantes, varillas o grietas; bájala si casi no tiene detalles.'
};
PARAM_DEFS.areaMolde = { label: 'Área de encofrado (molde) en contacto con el concreto', type: 'number', suffix: 'm²', default: 100 };
PARAM_DEFS.aplicacionesMolde = { label: 'Número de aplicaciones (una por cada vaciado)', type: 'number', suffix: 'veces', default: 1, hint: 'Un molde que se reutiliza se desmolda cada vez: el desmoldante se aplica de nuevo en cada vaciado.' };
PARAM_DEFS.areaCurado = { label: 'Área de concreto fresco a curar', type: 'number', suffix: 'm²', default: 100 };
PARAM_DEFS.areaFH = { label: 'Área del piso a endurecer', type: 'number', suffix: 'm²', default: 100 };
PARAM_DEFS.areaDrenaje = { label: 'Área de muro o cimentación a proteger con la lámina', type: 'number', suffix: 'm²', default: 100 };
PARAM_DEFS.longBordeDrenaje = { label: 'Longitud del borde superior de la lámina de drenaje', type: 'number', suffix: 'm', default: 30 };
PARAM_DEFS.m3SbrPanete  = { label: 'Volumen de arena del mortero de pañete (SBR Látex)',       type: 'number', suffix: 'm³', default: 1 };
PARAM_DEFS.m3SbrLechada = { label: 'Volumen de arena de la lechada (SBR Látex)',               type: 'number', suffix: 'm³', default: 1 };
PARAM_DEFS.m3SbrRev     = { label: 'Volumen de agregado del mortero de revestimiento (SBR Látex)', type: 'number', suffix: 'm³', default: 1 };
PARAM_DEFS.m3SbrShake   = { label: 'Volumen de arena del mortero de espolvoreo (SBR Látex)',   type: 'number', suffix: 'm³', default: 1 };
PARAM_DEFS.areaRepamerk      = { label: 'Área a reparar (Repamerk 301)',               type: 'number', suffix: 'm²', default: 2 };
PARAM_DEFS.espesorRepamerk   = { label: 'Espesor de reparación (Repamerk 301)',        type: 'number', suffix: 'mm', default: 20 };
PARAM_DEFS.nRepamerkHoyo     = { label: 'Número de huecos de varillas o conos (Repamerk 301)', type: 'number', suffix: 'unid.', default: 20 };
PARAM_DEFS.dRepamerkHoyo     = { label: 'Diámetro de cada hueco (Repamerk 301)',       type: 'number', suffix: 'mm', default: 25 };
PARAM_DEFS.profRepamerkHoyo  = { label: 'Profundidad de cada hueco (Repamerk 301)',    type: 'number', suffix: 'mm', default: 150 };


// "1 sacos" -> "1 saco": ajusta el sustantivo de la unidad cuando la cantidad es 1
// "1 sacos" -> "1 saco": ajusta el sustantivo de la unidad cuando la cantidad es 1
function unitWord(u, n){
  if (n !== 1) return u;
  const one = { sacos:'saco', kits:'kit', bolsas:'bolsa', cubetas:'cubeta', baldes:'balde', envases:'envase', paquetes:'paquete', sets:'set', rollos:'rollo', metros:'metro', perfiles:'perfil', salchichones:'salchichón', galones:'galón', tanques:'tanque', tambores:'tambor', cartuchos:'cartucho' };
  return u.replace(/^(sacos|kits|bolsas|cubetas|baldes|envases|paquetes|sets|rollos|metros|perfiles|salchichones|galones|tanques|tambores|cartuchos)\b/, m => one[m]);
}
function unitFor(product, n, presIdx){
  const u = (product.presentations && presIdx != null) ? product.presentations[presIdx].unit : product.unit;
  return unitWord(u, n);
}
/* =========================================================
   PRESENTACIONES (un mismo producto en varios tamaños)
   product.presentations = [{ id, label, unit, size, sku, name, price?, gal? }]
   · size  = cantidad del empaque en la misma unidad base que usa el cálculo (kg)
   · price = precio de lista con ITBIS (RD$). Si falta, esa presentación no entra en la comparación de costos.
   ========================================================= */
const CONFIG = {
  mostrarPrecios: true,          // false = muestra solo equivalencias, sin precios
  fuentePrecios: 'Shopify'   // de dónde salen los precios cargados
};
const pkgOf = (inputs, dflt) => (inputs._pkg > 0 ? inputs._pkg : dflt);
const money = n => 'RD$' + fmt(n, Math.abs(n - Math.round(n)) < 0.005 ? 0 : 2);
function presIdxOf(product, idx){ return product.presentations ? (idx != null ? idx : (product.defaultPres || 0)) : null; }
function displayName(product, pi){ return (product.presentations && pi != null) ? product.presentations[pi].name : product.name; }
function skuText(product, pi){
  if (product.presentations && pi != null){
    const x = product.presentations[pi];
    return ((x.sku && x.sku !== '—') ? 'SKU ' + x.sku : 'SKU por confirmar') + (x.borrador ? ' · en borrador en Shopify (no publicado)' : '');
  }
  return skuLabel(product);
}

// Combinación más económica de presentaciones que cubra la cantidad necesaria (menor costo; a igual costo, la que deja más producto)
function bestCombo(need, pp){
  const sorted = [...pp].sort((a, b) => b.size - a.size);
  let best = null;
  function consider(counts, cost, cover){
    cost = Math.round(cost * 100) / 100;
    const total = counts.reduce((x, y) => x + y, 0);
    if (!best || cost < best.cost - 1e-9 || (Math.abs(cost - best.cost) < 1e-9 && (cover > best.cover + 1e-9 || (Math.abs(cover - best.cover) < 1e-9 && total < best.total)))){
      best = { counts: counts.slice(), cost, cover, total };
    }
  }
  const last = sorted.length - 1;
  function rec(k, remaining, counts, cost, cover){
    if (k === last){
      const n = remaining > 1e-9 ? ceilTo(remaining / sorted[k].size) : 0;
      consider(counts.concat([n]), cost + n * sorted[k].price, cover + n * sorted[k].size);
      return;
    }
    const maxN = remaining > 1e-9 ? ceilTo(remaining / sorted[k].size) : 0;
    if (maxN > 20000) return;
    for (let n = 0; n <= maxN; n++){
      rec(k + 1, remaining - n * sorted[k].size, counts.concat([n]), cost + n * sorted[k].price, cover + n * sorted[k].size);
    }
  }
  rec(0, need, [], 0, 0);
  if (!best) return null;
  return { items: sorted.map((p, i) => ({ p, n: best.counts[i] })).filter(x => x.n > 0), cost: best.cost, cover: best.cover };
}

// Compara las presentaciones de un producto para la cantidad calculada y sugiere la más económica
function recomendar(product, mode, inputs, selIdx){
  const all = product.presentations;
  if (!all || all.length < 2 || product.noReco) return null;
  // Si las presentaciones tienen "group" (diámetro, sección...), solo se comparan las del mismo grupo
  const selP = all[selIdx];
  const pres = selP.group != null ? all.filter(p => p.group === selP.group) : all;
  if (pres.length < 2) return null;
  const rSel = mode.calc(Object.assign({}, inputs, { _pkg: selP.size, _pres: selP }));
  if (rSel.units == null) return null;
  // Cantidad necesaria (con margen) en la unidad base; las demás presentaciones se calculan sobre esa misma cantidad
  const need = (rSel.needKg != null) ? rSel.needKg : rSel.units * selP.size;
  if (!(need > 0)) return null;
  const opts = pres.map(p => {
    const units = ceilTo(need / p.size);
    return { i: all.indexOf(p), p, units, cost: (CONFIG.mostrarPrecios && p.price != null) ? units * p.price : null };
  });
  const sel = opts.find(o => o.i === selIdx);
  const priced = opts.filter(o => o.cost != null).map(o => o.p);
  const combo = priced.length ? bestCombo(need, priced) : null;
  return { opts, sel, need, combo };
}
function comboGal(items){ return items.every(x => x.p.gal != null) ? items.reduce((a, x) => a + x.n * x.p.gal, 0) : null; }
function comboText(combo){ return combo.items.map(x => `${x.n} ${unitWord(x.p.unit, x.n)}`).join(' + '); }
function galTxt(p, n){ return p.gal != null ? ` (${fmt(p.gal * n, p.gal * n % 1 ? 1 : 0)} gal)` : ''; }

function recoHTML(rec, selIdx, product){
  if (!rec) return '';
  const priced = rec.opts.some(o => o.cost != null);
  const bestCost = rec.combo ? rec.combo.cost : null;
  const rows = rec.opts.map(o => {
    const isSel = o.i === selIdx;
    return `<tr class="${isSel ? 'sel' : ''}">
      <td>${o.p.label}${isSel ? ' <span class="reco-tag">elegida</span>' : ''}</td>
      <td>${o.units} ${unitWord(o.p.unit, o.units)}</td>
      <td>${o.cost != null ? money(o.cost) : '<span class="muted">sin precio</span>'}</td>
    </tr>`;
  }).join('');

  let msg = '';
  if (rec.combo){
    const selCost = rec.sel.cost;
    const diff = selCost != null ? selCost - rec.combo.cost : null;
    const sameAsSel = rec.combo.items.length === 1 && rec.combo.items[0].p === rec.sel.p;
    const cg = comboGal(rec.combo.items), sg = rec.sel.p.gal != null ? rec.sel.units * rec.sel.p.gal : null;
    if (!sameAsSel && diff != null && Math.abs(diff) <= 0.005){
      msg = `<b>Mismo precio, más producto:</b> ${comboText(rec.combo)}${cg != null && sg != null ? ` (${fmtAuto(cg)} gal en total frente a ${fmtAuto(sg)} gal con la presentación elegida)` : ''} · ${money(rec.combo.cost)}.`;
    } else if (sameAsSel || (diff != null && diff <= 0.005)){
      msg = `<b>La presentación elegida ya es la más económica</b> para esta cantidad.`;
    } else {
      msg = `<b>Más económico:</b> ${comboText(rec.combo)} · <b>${money(rec.combo.cost)}</b>` +
            (diff != null ? ` · ahorras <b>${money(diff)}</b> (${fmt(diff / selCost * 100, 0)}%) frente a la presentación elegida` : '');
    }
  }
  const sinPrecio = rec.opts.filter(o => o.cost == null).map(o => o.p.label);
  const nota = priced
    ? `Precios publicados en la tienda en línea (${CONFIG.fuentePrecios}). No es una cotización: confirma precio y disponibilidad con tu asesor OSCO.` +
      (sinPrecio.length ? ` <b>No entra en la comparación:</b> ${sinPrecio.join(', ')} (sin precio cargado).` : '')
    : 'Equivalencias de la cantidad necesaria en cada presentación.';
  return `<div class="reco-box">
      <div class="reco-title">Presentaciones y mejor opción de compra</div>
      <table class="reco-table"><thead><tr><th>Presentación</th><th>Cantidad</th><th>${priced ? 'Costo' : ''}</th></tr></thead><tbody>${rows}</tbody></table>
      ${msg ? `<div class="reco-msg">${msg}</div>` : ''}
      <div class="reco-note">${nota}</div>
    </div>`;
}
function recoCompact(rec, selIdx){
  if (!rec || !rec.combo) return '';
  const selCost = rec.sel.cost, diff = selCost != null ? selCost - rec.combo.cost : null;
  const sameAsSel = rec.combo.items.length === 1 && rec.combo.items[0].p === rec.sel.p;
  const sinPrecio = rec.opts.filter(o => o.cost == null).map(o => o.p.label);
  const aviso = sinPrecio.length ? ` <span style="opacity:.7">(sin comparar: ${sinPrecio.join(', ')}, sin precio)</span>` : '';
  if (!sameAsSel && diff != null && Math.abs(diff) <= 0.005){
    const cg = comboGal(rec.combo.items), sg = rec.sel.p.gal != null ? rec.sel.units * rec.sel.p.gal : null;
    return `<div class="mrc-reco">Mismo precio, más producto: <b>${comboText(rec.combo)}</b>${cg != null && sg != null ? ` (${fmtAuto(cg)} gal vs ${fmtAuto(sg)} gal)` : ''} · ${money(rec.combo.cost)}${aviso}</div>`;
  }
  if (sameAsSel || (diff != null && diff <= 0.005)) return `<div class="mrc-reco ok">Presentación elegida: ya es la más económica.${aviso}</div>`;
  return `<div class="mrc-reco">Más económico: <b>${comboText(rec.combo)}</b> · ${money(rec.combo.cost)}${diff != null ? ` · ahorras <b>${money(diff)}</b>` : ''}${aviso}</div>`;
}
const fmtAuto = n => fmt(n, Number.isInteger(n) ? 0 : 1);
function skuLabel(p){
  if (p.aliases){
    return 'Códigos ' + p.aliases.map(a => a.sku).join(' · ') + ' (y los demás de la marca) · nombres por confirmar';
  }
  if (p.presentations && p.presentations.length > 4){
    return p.presentations.length + ' referencias · SKU ' + p.presentations.slice(0, 4).map(x => x.sku).join(' · ') + ' …';
  }
  if (p.presentations){
    return p.presentations.length + ' presentaciones · SKU ' + p.presentations.map(x => (x.sku && x.sku !== '—') ? x.sku : 'por confirmar').join(' / ');
  }
  const base = (p.sku && p.sku !== '—') ? 'SKU ' + p.sku : 'SKU por confirmar';
  return p.provisional ? base + ' · nombre por confirmar' : base;
}
function fmt(n, dec){ return Number(n).toLocaleString('es-DO', {minimumFractionDigits: dec, maximumFractionDigits: dec}); }
function ceilTo(n){ return Math.ceil(n - 1e-9); }
function cementoPorM3(resistencia){ return dosingTable.find(r => r.resistencia === parseFloat(resistencia)).cemento; }
// Si el cliente aporta la dosificación de su propia mezcla (kg de cemento/m³), tiene prioridad sobre la tabla estándar.
function usaMezclaPropia(inputs){
  return inputs.usarCementoPropio === true && parseFloat(inputs.cementoPropio) > 0;
}
function cementoDesdeInputs(inputs){
  return usaMezclaPropia(inputs) ? parseFloat(inputs.cementoPropio) : cementoPorM3(inputs.resistencia);
}

/* =========================================================
   CATEGORÍAS (nueva estructura del catálogo, sep-2026)
   Un solo lugar para renombrar o reagrupar: los productos
   apuntan a CATEGORIES.<clave>.name. Pendiente de aprobación
   final de Osvaldo.
   ========================================================= */
const MERCADO_CONSTRUCCION = 'Soluciones para la Construcción';
const MERCADO_IMPERMEABILIZACION = 'Soluciones para Impermeabilización';
const CATEGORIES = {
  aditivos:        { name: 'Aditivos de Mortero y Concreto',               mercado: MERCADO_CONSTRUCCION },
  fibras:          { name: 'Fibras de Refuerzo para Concreto',             mercado: MERCADO_CONSTRUCCION },
  reparaciones:    { name: 'Reparaciones y Reforzamientos Estructurales',  mercado: MERCADO_CONSTRUCCION },
  superficie:      { name: 'Preparación de Superficie',                    mercado: MERCADO_CONSTRUCCION },
  curado:          { name: 'Curado y Acabado de Concreto',                 mercado: MERCADO_CONSTRUCCION },
  pisos:           { name: 'Sistemas para Pisos',                          mercado: MERCADO_CONSTRUCCION },
  juntas:          { name: 'Sistemas de Sellado de Juntas',                mercado: MERCADO_CONSTRUCCION },
  drenaje:         { name: 'Sistemas de Drenaje y Manejo de Agua',         mercado: MERCADO_CONSTRUCCION },
  imprimantes:     { name: 'Imprimantes',                                  mercado: MERCADO_IMPERMEABILIZACION },
  asfalticos:      { name: 'Impermeabilizantes Asfálticos (Membranas)',    mercado: MERCADO_IMPERMEABILIZACION },
  liquidos:        { name: 'Impermeabilizantes Líquidos (Membranas)',      mercado: MERCADO_IMPERMEABILIZACION },
  cementicios:     { name: 'Impermeabilizantes Cementicios',               mercado: MERCADO_IMPERMEABILIZACION },
  telas:           { name: 'Telas de Refuerzo para Membranas',             mercado: MERCADO_IMPERMEABILIZACION },
  revestimientos:  { name: 'Revestimientos y Pinturas Reflectivas',        mercado: MERCADO_IMPERMEABILIZACION },
  bituminosos:     { name: 'Selladores Bituminosos',                       mercado: MERCADO_IMPERMEABILIZACION }
};

// Fibermix: 1 bolsa de 2.2 kg por m³ (1.8 kg macrofibra + 0.4 kg microfibra), según su ficha técnica
function fiberCalc(m3){
  return { m3, units: ceilTo(m3), macroKg: m3 * 1.8, microKg: m3 * 0.4, totalKg: m3 * 2.2, sbrCubetas: ceilTo(m3 / 5) };
}
function fiberDesc(r, base){
  return `${base} = <b>${r.units}</b> bolsas de 2.2 kg (≈ <b>${fmt(r.macroKg,0)} kg</b> de macrofibra + <b>${fmt(r.microKg,0)} kg</b> de microfibra).`;
}

/* =========================================================
   CATÁLOGO DE PRODUCTOS
   ========================================================= */
const PRODUCTS = {

  crystal_c320: {
    id: 'crystal_c320',
    name: 'CRYSTAL C 320 (Aditivo Hidrófugo Cristalino) 5 gl',
    provider: 'Baumerk',
    sku: '9029',
    category: CATEGORIES.aditivos.name,
    params: ['resistencia', 'volumen'],
    hasRange: true,
    unit: 'cubetas de 5 gal',
    unitsRowLabel: 'Cubetas a comprar',
    presentationKg: 21.77,
    range: {
      label: 'Dosificación a aplicar',
      readoutLabel: 'Dosis seleccionada',
      unit: '%',
      min: 0.8, prom: 1.15, max: 1.5, step: 0.01,
      hint: 'Rango autorizado por ficha técnica: 0.8%–1.5% del peso de cemento.',
      amountLabel: 'Kg de aditivo',
      amountUnit: 'kg'
    },
    // Cantidad necesaria a un valor dado del rango (pct de cemento)
    calcAt(inputs, pct){
      const cemento = cementoDesdeInputs(inputs) * parseFloat(inputs.volumen || 0);
      const amount = cemento * (pct / 100);
      return { amount, units: ceilTo(amount / this.presentationKg) };
    },
    contextRow(inputs){
      const cemento = cementoDesdeInputs(inputs) * parseFloat(inputs.volumen || 0);
      return { label: usaMezclaPropia(inputs) ? 'Cemento total (mezcla propia)' : 'Cemento total', value: fmt(cemento, 1) + ' kg' };
    }
  },

  pg800: {
    id: 'pg800',
    name: 'PG 800 (Recubrimiento Asfáltico Emulsionado para Techos) 5 gl',
    provider: 'Polyglass USA',
    sku: '5006',
    category: CATEGORIES.liquidos.name,
    params: ['area'],
    hasRange: true,
    unit: 'baldes de 5 gal',
    unitsRowLabel: 'Baldes a comprar',
    presentationGal: 5,
    range: {
      label: 'Consumo a aplicar',
      readoutLabel: 'Consumo seleccionado',
      unit: ' gal/100 ft²',
      min: 3, prom: 3.5, max: 4, step: 0.05,
      hint: 'Rango según ficha técnica de Polyglass: 3–4 galones por 100 pies cuadrados (≈ 1.2–1.6 L/m²). Cálculo por capa aplicada.',
      amountLabel: 'Galones necesarios',
      amountUnit: 'gal'
    },
    // Cantidad necesaria a un valor dado del rango (gal por 100 ft²)
    calcAt(inputs, galPer100ft2){
      const areaM2 = parseFloat(inputs.area || 0);
      const ft2 = areaM2 * 10.7639;
      const amount = (ft2 / 100) * galPer100ft2;
      return { amount, units: ceilTo(amount / this.presentationGal) };
    },
    contextRow(inputs){
      const areaM2 = parseFloat(inputs.area || 0);
      return { label: 'Área a cubrir', value: fmt(areaM2, 1) + ' m² (' + fmt(areaM2 * 10.7639, 0) + ' ft²)' };
    }
  },

  microfibra: {
    id: 'microfibra',
    name: 'Microfibra de Polipropileno (Refuerzo Secundario para Concreto) 600 g',
    provider: 'Sapen',
    sku: '9017',
    category: CATEGORIES.fibras.name,
    params: ['volumen'],
    hasRange: false,
    unit: 'bolsas de 600 g',
    dosis: 0.6, // kg/m3, dosis estándar única de referencia
    presentationKg: 0.6,
    calc(inputs){
      const kg = this.dosis * parseFloat(inputs.volumen || 0);
      return { kg, units: ceilTo(kg / this.presentationKg) };
    }
  },

  powlog: {
    id: 'powlog',
    name: 'POWLOG (Aditivo Hidrófugo en Polvo) 500 g',
    provider: 'Baumerk',
    sku: '9015',
    category: CATEGORIES.aditivos.name,
    hasRange: false,
    unit: 'paquetes de 500 g',
    // Este producto no usa params/calc directos: tiene dos modos seleccionables.
    modes: [
      {
        id: 'por_diseño',
        label: 'Por volumen y resistencia',
        params: ['resistencia', 'volumen'],
        calc(inputs){
          const cemento = cementoDesdeInputs(inputs) * parseFloat(inputs.volumen || 0);
          const kg = cemento * 0.01; // dosis fija: 1% del peso de cemento (500g / 50kg)
          return { cementoTotal: cemento, kg, units: ceilTo(kg / 0.5) };
        },
        describe(r){
          return `Dosis fija de ficha técnica: <b>1% del peso de cemento</b> (cemento total: <b>${fmt(r.cementoTotal,1)} kg</b>) · equivale a <b>${fmt(r.kg,1)} kg</b> de producto.`;
        },
        multiNote: () => 'dosis fija 1% del peso de cemento'
      },
      {
        id: 'por_fundas',
        label: 'Por número de fundas de cemento',
        params: ['fundasCemento'],
        calc(inputs){
          const fundas = parseFloat(inputs.fundasCemento || 0);
          return { fundas, units: ceilTo(fundas) }; // 1 funda 50kg = 1 paquete 500g, relación 1:1
        },
        describe(){
          return `Relación fija de ficha técnica: <b>1 funda de cemento (50 kg) = 1 paquete de POWLOG (500 g)</b>.`;
        },
        multiNote: () => 'por fundas de cemento'
      }
    ]
  },

  macrofibra: {
    id: 'macrofibra',
    name: 'Macrofibra Estructural (Refuerzo Primario para Concreto) 5 kg',
    provider: 'Polyfibers',
    sku: '9019',
    category: CATEGORIES.fibras.name,
    hasRange: false,
    unit: 'bolsas de 5 kg',
    bagKg: 5,
    // En multi muestra la dosis usada (varía por proyecto, la confirma Polyfibers)
    multiNote: (inputs) => `dosis ${fmt(parseFloat(inputs.dosisMacrofibra || 0), 1)} kg/m³ (confirmar con Polyfibers)`,
    modes: [
      {
        id: 'por_volumen',
        label: 'Por volumen (m³)',
        params: ['volumen', 'dosisMacrofibra'],
        calc(inputs){
          const m3 = parseFloat(inputs.volumen || 0);
          const dosis = parseFloat(inputs.dosisMacrofibra || 0);
          const kg = m3 * dosis;
          return { m3, dosis, kg, units: ceilTo(kg / 5), unitsRefMin: ceilTo(m3 * 2 / 5), unitsRefMax: ceilTo(m3 * 5 / 5) };
        },
        describe(r){
          return `<b>${fmt(r.m3,1)} m³</b> × <b>${fmt(r.dosis,1)} kg/m³</b> = <b>${fmt(r.kg,0)} kg</b> de macrofibra, redondeado hacia arriba a bolsas de 5 kg.`;
        },
        footnote: 'La dosis la define el proyecto (espesor, suelo, cargas y tráfico) y la confirma Polyfibers; no se deduce de la resistencia del concreto. Referencia de ficha: 2 kg/m³ serían {min} bolsas y 5 kg/m³ serían {max}.',
        multiNote: (inputs) => `dosis ${fmt(parseFloat(inputs.dosisMacrofibra || 0), 1)} kg/m³ (confirmar con Polyfibers)`
      },
      {
        id: 'por_area',
        label: 'Por área y espesor',
        params: ['areaLosa', 'espesorLosa', 'dosisMacrofibra'],
        calc(inputs){
          const area = parseFloat(inputs.areaLosa || 0);
          const esp = parseFloat(inputs.espesorLosa || 0);
          const m3 = area * (esp / 100);
          const dosis = parseFloat(inputs.dosisMacrofibra || 0);
          const kg = m3 * dosis;
          return { area, esp, m3, dosis, kg, units: ceilTo(kg / 5), unitsRefMin: ceilTo(m3 * 2 / 5), unitsRefMax: ceilTo(m3 * 5 / 5) };
        },
        describe(r){
          return `${fmt(r.area,0)} m² × ${fmt(r.esp,0)} cm = <b>${fmt(r.m3,1)} m³</b> de concreto · × <b>${fmt(r.dosis,1)} kg/m³</b> = <b>${fmt(r.kg,0)} kg</b> de macrofibra.`;
        },
        footnote: 'La dosis la define el proyecto (espesor, suelo, cargas y tráfico) y la confirma Polyfibers; no se deduce de la resistencia del concreto. Referencia de ficha: 2 kg/m³ serían {min} bolsas y 5 kg/m³ serían {max}.',
        multiNote: (inputs) => `dosis ${fmt(parseFloat(inputs.dosisMacrofibra || 0), 1)} kg/m³ (confirmar con Polyfibers)`
      }
    ]
  },

  fibermix: {
    id: 'fibermix',
    name: 'FIBERMIX (Refuerzo Primario y Secundario para Concreto) 2.2 kg',
    provider: 'Osco · Polyfibers + Sapen',
    sku: '9023',
    category: CATEGORIES.fibras.name,
    hasRange: false,
    modeTitle: 'Uso',
    unit: 'bolsas de 2.2 kg',
    modes: [
      {
        id: 'losa_volumen',
        label: 'Losa sobre terreno · por m³',
        params: ['volumen'],
        calc(inputs){ const m3 = parseFloat(inputs.volumen || 0); return fiberCalc(m3); },
        describe(r){ return fiberDesc(r, `<b>${fmtAuto(r.m3)} m³</b> × 1 bolsa/m³`); },
        footnote: 'Dosis de ficha: 1 bolsa de 2.2 kg por m³ (1.8 kg de macrofibra + 0.4 kg de microfibra), la mínima aprobada por el ICC-ES ESR-4595 para sustituir la malla en losas sobre terreno (aceras, patios, parqueos de autos, zapatas y losas de concreto simple). No sustituye el refuerzo estructural ni las juntas; el ingeniero de la obra aprueba el uso. Opcional: ~1 galón de SBR Látex 35-40 por m³ ({sbr} cubetas de 5 gl).',
        multiNote: () => '1 bolsa por m³ · losa sobre terreno'
      },
      {
        id: 'losa_area',
        label: 'Losa sobre terreno · por área y espesor',
        params: ['areaLosa', 'espesorLosa'],
        calc(inputs){
          const area = parseFloat(inputs.areaLosa || 0), esp = parseFloat(inputs.espesorLosa || 0);
          const r = fiberCalc(area * esp / 100); r.area = area; r.esp = esp; return r;
        },
        describe(r){ return fiberDesc(r, `${fmt(r.area,0)} m² × ${fmt(r.esp,0)} cm = <b>${fmtAuto(r.m3)} m³</b> × 1 bolsa/m³`); },
        footnote: 'Dosis de ficha: 1 bolsa de 2.2 kg por m³ (1.8 kg de macrofibra + 0.4 kg de microfibra), la mínima aprobada por el ICC-ES ESR-4595 para sustituir la malla en losas sobre terreno. No sustituye el refuerzo estructural ni las juntas; el ingeniero de la obra aprueba el uso. Opcional: ~1 galón de SBR Látex 35-40 por m³ ({sbr} cubetas de 5 gl).',
        multiNote: () => '1 bolsa por m³ · losa sobre terreno'
      },
      {
        id: 'ingeniero',
        label: 'Tráfico pesado, industrial, losacero u otros',
        params: [],
        calc(){ return { units: null, blocked: true }; },
        describe(){
          return 'Con montacargas, accesos de camiones, pisos industriales, estanterías o losas sobre lámina colaborante (losacero, que exige mínimo 2.4 kg/m³ de macrofibra), <b>1 bolsa por m³ no es una dosis de diseño</b>: la calcula el ingeniero según las cargas. Lo mismo aplica a piscinas, prefabricados y reparaciones.';
        },
        footnote: 'Para estos casos use la Macrofibra Estructural con la dosis confirmada por Polyfibers, enviando la Hoja de Datos del Proyecto (clase del concreto, espesor, área, módulo de reacción, vehículos y carga por eje).',
        multiNote: () => 'requiere diseño del ingeniero',
        blockMsg: 'Requiere diseño del ingeniero: use Macrofibra con dosis confirmada.'
      }
    ]
  },

  grt20: {
    id: 'grt20',
    name: 'GRT 20 (Grout Cementicio Expansivo de Uso General) 25 kg',
    provider: 'Baumerk',
    sku: '1101',
    category: CATEGORIES.reparaciones.name,
    hasRange: false,
    modeTitle: 'Uso',
    unit: 'sacos de 25 kg',
    modes: [
      {
        id: 'placas',
        label: 'Relleno bajo placas, pies de máquina y camas',
        params: ['areaGrt20', 'espesorGrt20', 'margen'],
        calc(inputs){
          const area = parseFloat(inputs.areaGrt20 || 0), esp = parseFloat(inputs.espesorGrt20 || 0);
          const L = area * esp;                       // 1 m² × 1 mm = 1 L
          const r = conMargen(L * 2.0, 25, inputs);   // 2.0 kg de polvo por litro de mortero fresco
          r.area = area; r.esp = esp; r.L = L; return r;
        },
        describe(r){
          const w = (r.esp < 10 || r.esp > 30) ? warnTxt('La ficha permite 10 a 30 mm por capa. Fuera de ese rango se debe añadir agregado fino (máx. la mitad del peso de GRT 20) y el desempeño baja 20–40%.') : '';
          return `${fmt(r.area,1)} m² × ${fmt(r.esp,0)} mm = <b>${fmt(r.L,1)} L</b> de mortero × 2.0 kg/L = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'saco' : 'sacos'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.${w}`;
        },
        footnote: 'Consumo de ficha: ~2.0 kg de polvo por litro de mortero fresco; espesor recomendado de 10 a 30 mm por capa. Saco de 25 kg que se mezcla con 3–3.5 L de agua. Redondeo hacia arriba.',
        multiNote: () => 'relleno por área y espesor'
      },
      {
        id: 'cavidades',
        label: 'Relleno de cavidades, huecos y rebajes',
        params: ['volLGrt20', 'margen'],
        calc(inputs){
          const L = parseFloat(inputs.volLGrt20 || 0);
          const r = conMargen(L * 2.0, 25, inputs); r.L = L; return r;
        },
        describe(r){ return `<b>${fmt(r.L,1)} L</b> × 2.0 kg/L = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'saco' : 'sacos'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`; },
        footnote: 'Consumo de ficha: ~2.0 kg de polvo por litro de mortero fresco. Si la cavidad es más gruesa de 30 mm, se puede añadir agregado fino (hasta la mitad del peso de GRT 20) con una pérdida de desempeño de 20–40%.',
        multiNote: () => 'relleno por volumen'
      },
      {
        id: 'anclajes',
        label: 'Anclaje de pernos y varillas en concreto',
        params: ['nGrt20', 'dOrGrt20', 'dVarGrt20', 'profGrt20', 'margen'],
        calc(inputs){
          const g = volAnclajesL(inputs, 'Grt20');
          const r = conMargen(g.L * 2.0, 25, inputs); r.L = g.L; r.bad = g.bad; return r;
        },
        describe(r){
          if (r.bad) return warnTxt('El diámetro del orificio debe ser mayor que el de la varilla.');
          return `Volumen de los orificios: <b>${fmt(r.L,2)} L</b> × 2.0 kg/L = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'saco' : 'sacos'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`;
        },
        footnote: 'Estimado geométrico: volumen entre el orificio y la varilla × 2.0 kg de polvo por litro (ficha de GRT 20). Verifica el diseño de anclaje con el ingeniero.',
        multiNote: () => 'anclajes'
      }
    ]
  },

  watershock: {
    id: 'watershock',
    name: 'WATERSHOCK (Sellador Cementicio de Fugas de Fraguado Ultra Rápido) 5 kg',
    provider: 'Baumerk',
    sku: '1107',
    category: CATEGORIES.reparaciones.name,
    hasRange: false,
    modeTitle: 'Uso',
    unit: 'envases de 5 kg',
    modes: [
      {
        id: 'estimado',
        label: 'Sellado de fugas y grietas estáticas',
        params: ['kgWatershock'],
        calc(inputs){
          const kg = parseFloat(inputs.kgWatershock || 0);
          return { kg, units: ceilTo(kg / 5), units20: ceilTo(kg / 20) };
        },
        describe(r){ return `<b>${fmt(r.kg,1)} kg</b> estimados de producto → <b>${r.units}</b> envases de 5 kg (o <b>${r.units20}</b> de 20 kg).`; },
        footnote: 'Watershock no tiene un rendimiento fijo en su ficha (consumo variable según el tamaño y la profundidad de la zona a sellar), por eso la cantidad la estima el asesor. Se mezcla con 1.2–1.4 L de agua por cada 5 kg. No aplica en grietas dinámicas, juntas de expansión o de control, ni como repello.',
        multiNote: (inputs) => `${fmt(parseFloat(inputs.kgWatershock || 0),1)} kg estimados`
      }
    ]
  },

  epox305: {
    id: 'epox305',
    name: 'EPOX 305 (Mortero Epóxico Fluido de Anclaje y Adhesivo) 5 kg',
    provider: 'Baumerk',
    sku: '8005',
    category: CATEGORIES.reparaciones.name,
    hasRange: false,
    modeTitle: 'Uso',
    unit: 'kits de 5 kg',
    modes: [
      {
        id: 'adhesivo',
        label: 'Adhesivo, unión de piezas o concreto nuevo sobre viejo',
        params: ['areaEpox305', 'espesorEpox305', 'margen'],
        calc(inputs){
          const area = parseFloat(inputs.areaEpox305 || 0), esp = parseFloat(inputs.espesorEpox305 || 0);
          const r = conMargen(area * esp * 1.45, 5, inputs);   // 1.45 kg/m² por mm de espesor
          r.area = area; r.esp = esp; return r;
        },
        describe(r){
          const w = (r.esp < 2 || r.esp > 30) ? warnTxt('La ficha recomienda un espesor de 2 a 30 mm.') : '';
          return `${fmt(r.area,1)} m² × ${fmt(r.esp,1)} mm × 1.45 kg/m²·mm = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'kit' : 'kits'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.${w}`;
        },
        footnote: 'Consumo de ficha: 1.45 kg/m² por cada mm de espesor (mín. 2 mm, máx. 30 mm). Kit de 5 kg: componente A 3.75 kg + componente B 1.25 kg. Aplica de +10 °C a +20 °C.',
        multiNote: () => 'adhesivo / unión'
      },
      {
        id: 'anclajes',
        label: 'Anclaje de pernos, varillas y espárragos',
        params: ['nEpox305', 'dOrEpox305', 'dVarEpox305', 'profEpox305', 'margen'],
        calc(inputs){
          const g = volAnclajesL(inputs, 'Epox305');
          const r = conMargen(g.L * 1.7, 5, inputs); r.L = g.L; r.bad = g.bad; return r;   // densidad 1.7 kg/L
        },
        describe(r){
          if (r.bad) return warnTxt('El diámetro del orificio debe ser mayor que el de la varilla.');
          return `Volumen de los orificios: <b>${fmt(r.L,2)} L</b> × 1.7 kg/L = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'kit' : 'kits'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`;
        },
        footnote: 'Estimado geométrico: volumen entre el orificio y la varilla × densidad de ficha (1.7 g/cm³). En anclajes verticales la broca debe ser al menos 6 mm mayor que el refuerzo. Verifica el diseño con el ingeniero.',
        multiNote: () => 'anclajes'
      }
    ]
  },

  epox310: {
    id: 'epox310',
    name: 'EPOX 310 (Mortero Epóxico de Reparación y Relleno de Alto Desempeño) 15 kg',
    provider: 'Baumerk',
    sku: '8014',
    category: CATEGORIES.reparaciones.name,
    hasRange: false,
    modeTitle: 'Uso',
    unit: 'kits de 15 kg',
    modes: [
      {
        id: 'reparacion',
        label: 'Reparación o relleno por área y espesor',
        params: ['areaEpox310', 'espesorEpox310', 'margen'],
        calc(inputs){
          const area = parseFloat(inputs.areaEpox310 || 0), esp = parseFloat(inputs.espesorEpox310 || 0);
          const L = area * esp;                          // 1 m² × 1 mm = 1 L
          const r = conMargen(L * 1.95, 15, inputs);     // densidad de la mezcla 1.90–2.00 kg/L (punto medio)
          r.unitsRefMin = conMargen(L * 1.90, 15, inputs).units; r.unitsRefMax = conMargen(L * 2.00, 15, inputs).units;
          r.area = area; r.esp = esp; r.L = L; return r;
        },
        describe(r){
          const w = (r.esp > 50) ? warnTxt('La ficha permite hasta 50 mm por capa; aplica en varias capas esperando 10–48 h entre una y otra.') : '';
          return `${fmt(r.area,1)} m² × ${fmt(r.esp,0)} mm = <b>${fmt(r.L,1)} L</b> × 1.95 kg/L = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'kit' : 'kits'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.${w}`;
        },
        footnote: 'La ficha da el consumo como variable; la cantidad se calcula con la densidad de la mezcla (1.90–2.00 g/cm³; aquí 1.95): {rango} kits según la densidad real. Juego de 15 kg (A/B/C = 2/1/12 por peso), hasta 50 mm por capa.',
        multiNote: () => 'reparación por área y espesor'
      },
      {
        id: 'juntas',
        label: 'Relleno de juntas o grietas por longitud',
        params: ['longEpox310', 'anchoEpox310', 'profEpox310', 'margen'],
        calc(inputs){
          const len = parseFloat(inputs.longEpox310 || 0), w = parseFloat(inputs.anchoEpox310 || 0), d = parseFloat(inputs.profEpox310 || 0);
          const L = len * w * d / 1000;                  // m × mm × mm = mL×1000 → litros
          const r = conMargen(L * 1.95, 15, inputs);
          r.unitsRefMin = conMargen(L * 1.90, 15, inputs).units; r.unitsRefMax = conMargen(L * 2.00, 15, inputs).units;
          r.len = len; r.w = w; r.d = d; r.L = L; return r;
        },
        describe(r){ return `${fmt(r.len,1)} m × ${fmt(r.w,0)} mm × ${fmt(r.d,0)} mm = <b>${fmt(r.L,2)} L</b> × 1.95 kg/L = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'kit' : 'kits'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`; },
        footnote: 'Cantidad calculada con la densidad de la mezcla (1.90–2.00 g/cm³): {rango} kits según la densidad real. Juego de 15 kg. Para juntas con movimiento considera un sellador flexible.',
        multiNote: () => 'juntas y grietas'
      }
    ]
  },

  g1107: {
    id: 'g1107',
    name: '1107 Advantage Grout (Grout Cementicio sin Retracción) 50 lb',
    provider: 'Dayton Superior',
    sku: '1119',
    category: CATEGORIES.reparaciones.name,
    hasRange: false,
    modeTitle: 'Uso',
    unit: 'sacos de 22.7 kg',
    modes: [
      {
        id: 'placas',
        label: 'Grouteo bajo placas base, maquinaria y apoyos (hasta 7.6 cm)',
        params: ['areaG1107', 'espesorG1107', 'margen'],
        calc(inputs){
          const area = parseFloat(inputs.areaG1107 || 0), esp = parseFloat(inputs.espesorG1107 || 0);
          const m3 = area * esp / 1000;
          const sacks = m3 / 0.0122;                       // 0.0122 m³ por saco (consistencia vertible)
          const m = Math.max(parseFloat(inputs.margen || 0), 0) / 100;
          return { area, esp, m3, kg: sacks * 22.7, netUnits: ceilTo(sacks), units: ceilTo(sacks * (1 + m)), margenPct: m * 100 };
        },
        describe(r){
          let w = '';
          if (r.esp > 76) w = warnTxt('Sobre 7.6 cm la ficha pide añadir grava lavada de 3/8″: usa el uso “más de 7.6 cm”.');
          return `${fmt(r.area,2)} m² × ${fmt(r.esp,0)} mm = <b>${fmt(r.m3,3)} m³</b> ÷ 0.0122 m³/saco · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'saco' : 'sacos'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.${w}`;
        },
        footnote: 'Rendimiento de ficha: 0.0122 m³ (0.43 pie³) por saco de 22.7 kg (50 lb), consistencia vertible. Rellena desde un solo lado con caja de vaciado y cura la superficie expuesta.',
        multiNote: () => 'grouteo hasta 7.6 cm'
      },
      {
        id: 'grava',
        label: 'Colocaciones de más de 7.6 cm (con grava)',
        params: ['areaG1107', 'espesorG1107', 'margen'],
        calc(inputs){
          const area = parseFloat(inputs.areaG1107 || 0), esp = parseFloat(inputs.espesorG1107 || 0);
          const m3 = area * esp / 1000;
          const sacks = m3 / 0.017;                        // 0.017 m³ por saco extendido con 11.34 kg de grava
          const m = Math.max(parseFloat(inputs.margen || 0), 0) / 100;
          const units = ceilTo(sacks * (1 + m));
          return { area, esp, m3, kg: sacks * 22.7, netUnits: ceilTo(sacks), units, margenPct: m * 100, gravaKg: units * 11.34 };
        },
        describe(r){
          let w = '';
          if (r.esp < 76) w = warnTxt('Bajo 7.6 cm no se añade grava: usa el uso “hasta 7.6 cm”.');
          if (r.esp > 152) w = warnTxt('Sobre 15 cm la ficha pide consultar a Servicios Técnicos de Dayton Superior antes de iniciar.');
          return `${fmt(r.area,2)} m² × ${fmt(r.esp,0)} mm = <b>${fmt(r.m3,3)} m³</b> ÷ 0.017 m³/saco · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'saco' : 'sacos'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>. Grava lavada de 3/8″: <b>${fmt(r.gravaKg,0)} kg</b> (11.34 kg por saco).${w}`;
        },
        footnote: 'Rendimiento de ficha con 25 lb (11.34 kg) de grava de guijarro lavada de 3/8″ por saco: 0.017 m³ (0.59 pie³) por saco. La grava no la vende este producto: confirma si OSCO la suministra. (Lectura de la ficha: verificar la etiqueta de este rendimiento con Dayton Superior.)',
        multiNote: () => 'grouteo con grava'
      },
      {
        id: 'anclajes',
        label: 'Anclaje de pernos y espárragos',
        params: ['nG1107', 'dOrG1107', 'dVarG1107', 'profG1107', 'margen'],
        calc(inputs){
          const g = volAnclajesL(inputs, 'G1107');
          const sacks = (g.L / 1000) / 0.0122;
          const m = Math.max(parseFloat(inputs.margen || 0), 0) / 100;
          return { L: g.L, bad: g.bad, kg: sacks * 22.7, netUnits: ceilTo(sacks), units: ceilTo(sacks * (1 + m)), margenPct: m * 100 };
        },
        describe(r){
          if (r.bad) return warnTxt('El diámetro del orificio debe ser mayor que el de la varilla.');
          return `Volumen de los orificios: <b>${fmt(r.L,2)} L</b> ÷ 12.2 L/saco · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'saco' : 'sacos'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`;
        },
        footnote: 'Estimado geométrico con el rendimiento de ficha (0.0122 m³ por saco). Rellena primero los orificios de los pernos. Verifica el diseño de anclaje con el ingeniero.',
        multiNote: () => 'anclajes'
      }
    ]
  },

  lonas_polyglass: {
    id: 'lonas_polyglass',
    name: 'Lonas Asfálticas Polyglass (todas las referencias)',
    provider: 'Polyglass',
    sku: '—',
    category: CATEGORIES.asfalticos.name,
    hasRange: false,
    unit: 'rollos de 10 m',
    // Una sola calculadora para todas las lonas de esta marca disponibles y públicas en la tienda en línea (Shopify).
    // Cualquier código o nombre lleva aquí. size = m² útiles por rollo (largo × 1 m, menos 10 por ciento de traslapes).
    presLabel: 'Referencia',
    noReco: true,
    defaultPres: 0,
    presentations: [
      { id: '2028', label: 'Lona Asfáltica Granulada Gris 3.5 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2028', name: 'Lona Asfáltica Granulada Gris 3.5 kg – 10 m (TREND HS)', price: null },
      { id: '2029', label: 'Lona Asfáltica Granulada Roja 3.5 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2029', name: 'Lona Asfáltica Granulada Roja 3.5 kg – 10 m (TREND HS)', price: null },
      { id: '2031', label: 'Lona Asfáltica Granulada Gris 4 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2031', name: 'Lona Asfáltica Granulada Gris 4 kg – 10 m (TREND HS)', price: null },
      { id: '2039', label: 'Lona Asfáltica Lisa 3 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2039', name: 'Lona Asfáltica Lisa 3 kg – 10 m (TREND HS)', price: null },
      { id: '2041', label: 'Lona Asfáltica Lisa 4 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2041', name: 'Lona Asfáltica Lisa 4 kg – 10 m (TREND HS)', price: null },
      { id: '2043', label: 'Lona Asfáltica Granulada Gris 3.5 kg – 10 m (TREND VS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2043', name: 'Lona Asfáltica Granulada Gris 3.5 kg – 10 m (TREND VS)', price: null },
      { id: '2053', label: 'Lona Asfáltica Granulada Gris 5 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2053', name: 'Lona Asfáltica Granulada Gris 5 kg – 10 m (TREND HS)', price: null },
      { id: '2063', label: 'Lona Asfáltica Lisa 5 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2063', name: 'Lona Asfáltica Lisa 5 kg – 10 m (TREND HS)', price: null },
      { id: '2064', label: 'Lona Asfáltica Lisa 3.5 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2064', name: 'Lona Asfáltica Lisa 3.5 kg – 10 m (TREND HS)', price: null },
      { id: '2076', label: 'Lona Asfáltica Autoadhesiva Lisa 2 mm – 15 m (SPIDER P SA)', unit: 'rollos de 15 m', size: 13.5, roll: 15, sku: '2076', name: 'Lona Asfáltica Autoadhesiva Lisa 2 mm – 15 m (SPIDER P SA)', price: null },
      { id: '2077', label: 'Lona Asfáltica Autoadhesiva Granulada Gris 3.5 kg – 10 m (SPIDER P SA)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2077', name: 'Lona Asfáltica Autoadhesiva Granulada Gris 3.5 kg – 10 m (SPIDER P SA)', price: null }
    ],
    keywords: ['lona', 'lonas', 'membrana', 'asfáltica', 'asfaltica', 'polyglass', 'trend', 'trend hs', 'trend vs', 'spider', 'spider p sa', 'autoadhesiva', 'granulada', 'lisa', 'rollo'],
    sameCalcNote: 'Todas las lonas Polyglass de rollo de 10 m rinden igual: 9 m² útiles por rollo.',
    modes: [
      {
        id: 'rollos',
        label: 'Rollos de lona asfáltica',
        params: ['areaLona', 'capasLona'],
        calc(inputs){
          const area = parseFloat(inputs.areaLona || 0);
          const capas = Math.max(parseFloat(inputs.capasLona || 1), 1);
          const pkg = pkgOf(inputs, 9);
          const m2 = area * capas;
          return { area, capas, m2, pkg, units: ceilTo(m2 / pkg) };
        },
        describe(r){
          const cap = r.capas === 1 ? '1 capa' : `${fmtAuto(r.capas)} capas`;
          return `${fmt(r.area,1)} m² × ${cap} = <b>${fmt(r.m2,1)} m²</b> ÷ <b>${fmt(r.pkg,1)} m² útiles por rollo</b>, redondeado hacia arriba.`;
        },
        footnote: 'Rollo de 1 × 10 m (10 m²) que rinde 9 m² útiles: el 10% restante se va en los traslapes (≈10 cm laterales y 15 cm en los extremos). El espesor, el acabado o el refuerzo no cambian el área que cubre el rollo. Si se coloca en dos capas, las juntas de la segunda deben quedar centradas sobre las de la primera. Excepción: SPIDER P SA Lisa 2 mm (SKU 2076) viene en rollo de 1 × 15 m; con el mismo 10% de traslape rinde 13.5 m² útiles (la tienda en línea lo lista como 15 m²: confirmar).',
        multiNote: (inputs) => `${fmtAuto(Math.max(parseFloat(inputs.capasLona || 1), 1))} capa(s)`
      }
    ]
  },

  lonas_baumerk: {
    id: 'lonas_baumerk',
    name: 'Lonas Asfálticas Baumerk (todas las referencias)',
    provider: 'Baumerk',
    sku: '—',
    category: CATEGORIES.asfalticos.name,
    hasRange: false,
    unit: 'rollos de 10 m',
    // Una sola calculadora para todas las lonas de esta marca disponibles y públicas en la tienda en línea (Shopify).
    // Cualquier código o nombre lleva aquí. size = m² útiles por rollo (largo × 1 m, menos 10 por ciento de traslapes).
    presLabel: 'Referencia',
    noReco: true,
    defaultPres: 0,
    presentations: [
      { id: '2049', label: 'Lona Asfáltica Granulada Gris 4 kg – 10 m (APP Baumerk)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2049', name: 'Lona Asfáltica Granulada Gris 4 kg – 10 m (APP Baumerk)', price: null },
      { id: '2075', label: 'Lona Asfáltica Granulada Gris 4 kg – 10 m (SILVERTECH WP 40 G)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2075', name: 'Lona Asfáltica Granulada Gris 4 kg – 10 m (SILVERTECH WP 40 G)', price: null }
    ],
    keywords: ['lona', 'lonas', 'membrana', 'asfáltica', 'asfaltica', 'baumerk', 'app', 'silvertech', 'granulada', 'rollo'],
    sameCalcNote: 'Todas las lonas Baumerk rinden igual: 9 m² útiles por rollo de 10 m.',
    modes: [
      {
        id: 'rollos',
        label: 'Rollos de lona asfáltica',
        params: ['areaLona', 'capasLona'],
        calc(inputs){
          const area = parseFloat(inputs.areaLona || 0);
          const capas = Math.max(parseFloat(inputs.capasLona || 1), 1);
          const pkg = pkgOf(inputs, 9);
          const m2 = area * capas;
          return { area, capas, m2, pkg, units: ceilTo(m2 / pkg) };
        },
        describe(r){
          const cap = r.capas === 1 ? '1 capa' : `${fmtAuto(r.capas)} capas`;
          return `${fmt(r.area,1)} m² × ${cap} = <b>${fmt(r.m2,1)} m²</b> ÷ <b>${fmt(r.pkg,1)} m² útiles por rollo</b>, redondeado hacia arriba.`;
        },
        footnote: 'Rollo de 1 × 10 m (10 m²) que rinde 9 m² útiles: el 10% restante se va en los traslapes (≈10 cm laterales y 15 cm en los extremos). El espesor, el acabado o el refuerzo no cambian el área que cubre el rollo. Si se coloca en dos capas, las juntas de la segunda deben quedar centradas sobre las de la primera.',
        multiNote: (inputs) => `${fmtAuto(Math.max(parseFloat(inputs.capasLona || 1), 1))} capa(s)`
      }
    ]
  },

  primer_baliu: {
    id: 'primer_baliu',
    name: 'Primer Asfáltico Baliu (Imprimante Asfáltico Emulsionado)',
    provider: 'Baliu',
    sku: '1011',
    category: CATEGORIES.imprimantes.name,
    hasRange: false,
    unit: 'cubetas de 5 gal',
    defaultPres: 0,
    presentations: [
      { id: '5gl',  label: 'Cubeta 5 gl',  unit: 'cubetas de 5 gal',  size: 5,  gal: 5,  sku: '1011', name: 'Primer Asfáltico Baliu (Imprimante Asfáltico Emulsionado) 5 gl', price: 2587.5 },
      { id: '50gl', label: 'Tanque 50 gl', unit: 'tanques de 50 gal', size: 50, gal: 50, sku: '1012', name: 'Primer Asfáltico Baliu (Imprimante Asfáltico Emulsionado) 50 gl', price: 21579.75 }
    ],
    modes: [
      {
        id: 'imprimar',
        label: 'Imprimar la superficie',
        params: ['areaTecho'],
        calc(inputs){
          const area = parseFloat(inputs.areaTecho || 0);
          const gal = area / 14;                                  // ficha: ~14 m² por galón
          return { area, gal, units: ceilTo(gal / pkgOf(inputs, 5)), needKg: gal };
        },
        describe(r){ return `${fmt(r.area,1)} m² ÷ 14 m² por galón = <b>${fmt(r.gal,1)} gal</b>, redondeado hacia arriba al envase.`; },
        footnote: 'Rendimiento de ficha: ~14 m² por galón (5 gal ≈ 70 m²; tanque de 50 gal ≈ 700 m²), según la porosidad y la absorción de la superficie: un concreto muy poroso o reseco gasta más. Se aplica en una capa uniforme con brocha, rodillo o pistola y se deja secar 4–5 horas antes de colocar la lona.',
        multiNote: () => '~14 m² por galón'
      }
    ]
  },

  cemento_plastico_baliu: {
    id: 'cemento_plastico_baliu',
    name: 'Cemento Plástico Baliu (Sellador Bituminoso)',
    provider: 'Baliu',
    sku: '3003',
    category: CATEGORIES.bituminosos.name,
    hasRange: false,
    unit: 'galones de 1 gal',
    defaultPres: 0,
    presentations: [
      { id: '1gl', label: '1 galón',     unit: 'galones de 1 gal', size: 1, gal: 1, sku: '3003', name: 'Cemento Plástico Baliu (Sellador Bituminoso) 1 gl', price: 828.0 },
      { id: '5gl', label: 'Cubeta 5 gl', unit: 'cubetas de 5 gal', size: 5, gal: 5, sku: '3002', name: 'Cemento Plástico Baliu (Sellador Bituminoso) 5 gl', price: 3312.0 }
    ],
    variableNote: 'El cemento plástico sirve para sellar detalles, y cuántos hay cambia mucho de un techo a otro: ventilas y respiraderos, tubos de aire, tuberías de agua que cruzan el techo, bajantes, varillas, grietas y juntas. Un techo puede tener un solo punto que sellar o diez. Por eso este cálculo es solo una guía (regla general de OSCO: 1 galón por cada 100 m²). Revisa tu techo y ajusta la cifra; ante la duda, la cubeta de 5 galones te cubre los imprevistos.',
    variableShort: 'Uso variable: depende de los detalles del techo (ventilas, tubos, bajantes, varillas, grietas). Estimado con 1 gal por cada 100 m².',
    modes: [
      {
        id: 'sellado',
        label: 'Sellado de grietas, juntas y puntos críticos',
        params: ['areaTecho', 'galCemento100'],
        calc(inputs){
          const area = parseFloat(inputs.areaTecho || 0);
          const f = parseFloat(inputs.galCemento100);
          const por100 = isNaN(f) ? 1 : f;
          const gal = area * por100 / 100;
          return { area, por100, gal, units: gal > 0 ? ceilTo(gal / pkgOf(inputs, 1)) : 0, needKg: gal };
        },
        describe(r){ return `${fmt(r.area,1)} m² × ${fmtAuto(r.por100)} gal por cada 100 m² = <b>${fmt(r.gal,1)} gal</b> <i>(estimado: el consumo real depende de los detalles del techo)</i>.`; },
        footnote: 'La ficha indica rendimiento variable (según el ancho y la profundidad de la grieta o junta y el espesor aplicado). En grietas anchas y puntos críticos se embebe una tela de refuerzo entre dos capas de producto. Envase de 1 galón o cubeta de 5 galones.',
        multiNote: (inputs) => `${fmtAuto(isNaN(parseFloat(inputs.galCemento100)) ? 1 : parseFloat(inputs.galCemento100))} gal por cada 100 m² (estimado)`
      }
    ]
  },

  pintura_aluminio: {
    id: 'pintura_aluminio',
    name: 'Pintura de Aluminio (Pintura Reflectiva): Baliu o Rooflex',
    provider: 'Baliu · Polyglass',
    sku: '3001',
    category: CATEGORIES.revestimientos.name,
    hasRange: false,
    unit: 'cubetas de 5 gal',
    presLabel: 'Marca',
    noReco: true,
    defaultPres: 0,
    // cons = m² por galón de referencia (una mano); consMin/consMax = extremos de la ficha
    presentations: [
      { id: 'baliu',   label: 'Baliu',   unit: 'cubetas de 5 gal', size: 5, gal: 5, sku: '3001', name: 'Pintura de Aluminio Baliu (Pintura Reflectiva) 5 gl', price: 3622.5, cons: 19,   consMin: 18,  consMax: 20 },
      { id: 'rooflex', label: 'Rooflex', unit: 'cubetas de 5 gal', size: 5, gal: 5, sku: '5011', name: 'Pintura de Aluminio Rooflex (Pintura Reflectiva) 5 gl', price: 5071.5, cons: 12.4, consMin: 9.3, consMax: 18.6 }
    ],
    modes: [
      {
        id: 'una_mano',
        label: 'Capa final reflectiva (una mano)',
        params: ['areaTecho'],
        calc(inputs){
          const pr = inputs._pres || PRODUCTS.pintura_aluminio.presentations[0];
          const area = parseFloat(inputs.areaTecho || 0);
          const gal = area / pr.cons;
          return { area, gal, cons: pr.cons, marca: pr.label, units: ceilTo(gal / pr.size),
                   unitsRefMin: ceilTo(area / pr.consMax / pr.size), unitsRefMax: ceilTo(area / pr.consMin / pr.size) };
        },
        describe(r){ return `${fmt(r.area,1)} m² ÷ ${fmt(r.cons,1)} m² por galón (${r.marca}) = <b>${fmt(r.gal,1)} gal</b>, redondeado hacia arriba a cubetas de 5 gal.`; },
        footnote: 'Rendimiento de referencia en una mano: Baliu 18–20 m² por galón (90–100 m² por cubeta); Rooflex 0.5–1 galón por 100 pies² (46–93 m² por cubeta, aquí el punto medio). Varía con la rugosidad, la absorción y la técnica: entre {min} y {max} cubetas. Se aplica sobre lona lisa, esperando al menos 15 días tras instalarla.',
        multiNote: () => 'una mano'
      }
    ]
  },

  polybrite_951: {
    id: 'polybrite_951',
    name: 'POLYBRITE 95.1 (Recubrimiento de Silicona para Techos) 5 gl',
    provider: 'Polyglass USA',
    sku: '5015',
    category: CATEGORIES.liquidos.name,
    hasRange: false,
    unit: 'cubetas de 5 gal',
    presLabel: 'Garantía',
    noReco: true,
    defaultPres: 0,
    // Rendimiento por cubeta de 18.9 L según la garantía (dato de Johanna, 2 nov 2026): 10 años 0.61 L/m² = 30.97 m²; 15 años 0.81 L/m² = 23.24 m²; 20 años 1.02 L/m² = 18.59 m². cons = m² por galón.
    presentations: [
      { id: 'g10', label: '10 años de garantía', unit: 'cubetas de 5 gal', size: 5, gal: 5, sku: '5015', name: 'POLYBRITE 95.1 (Recubrimiento de Silicona para Techos) 5 gl', price: 17077.5, litros: 0.61, rinde: 30.97, cons: 6.194, consMin: 6.194, consMax: 6.194 },
      { id: 'g15', label: '15 años de garantía', unit: 'cubetas de 5 gal', size: 5, gal: 5, sku: '5015', name: 'POLYBRITE 95.1 (Recubrimiento de Silicona para Techos) 5 gl', price: 17077.5, litros: 0.81, rinde: 23.24, cons: 4.648, consMin: 4.648, consMax: 4.648 },
      { id: 'g20', label: '20 años de garantía', unit: 'cubetas de 5 gal', size: 5, gal: 5, sku: '5015', name: 'POLYBRITE 95.1 (Recubrimiento de Silicona para Techos) 5 gl', price: 17077.5, litros: 1.02, rinde: 18.59, cons: 3.718, consMin: 3.718, consMax: 3.718 }
    ],
    modes: [
      {
        id: 'techo',
        label: 'Techo completo (según garantía)',
        params: ['areaTecho'],
        calc(inputs) {
          const pr = inputs._pres || PRODUCTS.polybrite_951.presentations[0];
          const area = parseFloat(inputs.areaTecho || 0);
          const gal = area / pr.cons;
          const units = ceilTo(area / pr.rinde);
          return { area, gal, litros: area * pr.litros, cons: pr.cons, lpm2: pr.litros, rinde: pr.rinde, marca: pr.label, units, unitsRefMin: units, unitsRefMax: units };
        },
        describe(r) {
          return fmt(r.area, 1) + ' m² × ' + fmt(r.lpm2, 2) + ' L/m² (' + r.marca + ') = <b>' + fmt(r.litros, 1) + ' L</b>. Cada cubeta de 18.9 L rinde ' + fmt(r.rinde, 2) + ' m², redondeado hacia arriba a cubetas completas.';
        },
        footnote: 'Rendimiento por cubeta de 18.9 L según los años de garantía: 10 años 0.61 L/m² (30.97 m²), 15 años 0.81 L/m² (23.24 m²) y 20 años 1.02 L/m² (18.59 m²). Sobre lona granulada, madera o concreto, aplica antes POLYBRITE 98.',
        multiNote: () => 'según garantía'
      }
    ]
  },

  lona_granulada: {
    id: 'lona_granulada',
    name: 'Lona asfáltica granulada (elige la referencia)',
    provider: 'Polyglass · Baumerk',
    sku: '—',
    hidden: true,   // solo se usa dentro de los sistemas de techo
    category: CATEGORIES.asfalticos.name,
    hasRange: false,
    unit: 'rollos de 10 m',
    presLabel: 'Lona',
    noReco: true,
    defaultPres: 0,
    presentations: [
      { id: '2028', label: 'Lona Asfáltica Granulada Gris 3.5 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2028', name: 'Lona Asfáltica Granulada Gris 3.5 kg – 10 m (TREND HS)', price: null },
      { id: '2029', label: 'Lona Asfáltica Granulada Roja 3.5 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2029', name: 'Lona Asfáltica Granulada Roja 3.5 kg – 10 m (TREND HS)', price: null },
      { id: '2031', label: 'Lona Asfáltica Granulada Gris 4 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2031', name: 'Lona Asfáltica Granulada Gris 4 kg – 10 m (TREND HS)', price: null },
      { id: '2043', label: 'Lona Asfáltica Granulada Gris 3.5 kg – 10 m (TREND VS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2043', name: 'Lona Asfáltica Granulada Gris 3.5 kg – 10 m (TREND VS)', price: null },
      { id: '2049', label: 'Lona Asfáltica Granulada Gris 4 kg – 10 m (APP Baumerk)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2049', name: 'Lona Asfáltica Granulada Gris 4 kg – 10 m (APP Baumerk)', price: null },
      { id: '2053', label: 'Lona Asfáltica Granulada Gris 5 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2053', name: 'Lona Asfáltica Granulada Gris 5 kg – 10 m (TREND HS)', price: null },
      { id: '2075', label: 'Lona Asfáltica Granulada Gris 4 kg – 10 m (SILVERTECH WP 40 G)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2075', name: 'Lona Asfáltica Granulada Gris 4 kg – 10 m (SILVERTECH WP 40 G)', price: null },
      { id: '2077', label: 'Lona Asfáltica Autoadhesiva Granulada Gris 3.5 kg – 10 m (SPIDER P SA)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2077', name: 'Lona Asfáltica Autoadhesiva Granulada Gris 3.5 kg – 10 m (SPIDER P SA)', price: null }
    ],
    modes: [
      {
        id: 'rollos',
        label: 'Rollos de lona granulada',
        params: ['areaTecho', 'capasLona'],
        calc(inputs){
          const area = parseFloat(inputs.areaTecho || 0), capas = Math.max(parseFloat(inputs.capasLona || 1), 1);
          const pkg = pkgOf(inputs, 9), m2 = area * capas;
          return { area, capas, m2, pkg, units: ceilTo(m2 / pkg) };
        },
        describe(r){ const cap = r.capas === 1 ? '1 capa' : `${fmtAuto(r.capas)} capas`; return `${fmt(r.area,1)} m² × ${cap} = <b>${fmt(r.m2,1)} m²</b> ÷ <b>${fmt(r.pkg,1)} m² útiles por rollo</b>, redondeado hacia arriba.`; },
        footnote: 'Rollo de 1 × 10 m (10 m²) que rinde 9 m² útiles: el 10% restante se va en los traslapes.',
        multiNote: (inputs) => `${fmtAuto(Math.max(parseFloat(inputs.capasLona || 1), 1))} capa(s)`
      }
    ]
  },

  lona_lisa: {
    id: 'lona_lisa',
    name: 'Lona asfáltica lisa (elige la referencia)',
    provider: 'Polyglass',
    sku: '—',
    hidden: true,   // solo se usa dentro de los sistemas de techo
    category: CATEGORIES.asfalticos.name,
    hasRange: false,
    unit: 'rollos de 10 m',
    presLabel: 'Lona',
    noReco: true,
    defaultPres: 0,
    presentations: [
      { id: '2039', label: 'Lona Asfáltica Lisa 3 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2039', name: 'Lona Asfáltica Lisa 3 kg – 10 m (TREND HS)', price: null },
      { id: '2041', label: 'Lona Asfáltica Lisa 4 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2041', name: 'Lona Asfáltica Lisa 4 kg – 10 m (TREND HS)', price: null },
      { id: '2063', label: 'Lona Asfáltica Lisa 5 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2063', name: 'Lona Asfáltica Lisa 5 kg – 10 m (TREND HS)', price: null },
      { id: '2064', label: 'Lona Asfáltica Lisa 3.5 kg – 10 m (TREND HS)', unit: 'rollos de 10 m', size: 9, roll: 10, sku: '2064', name: 'Lona Asfáltica Lisa 3.5 kg – 10 m (TREND HS)', price: null },
      { id: '2076', label: 'Lona Asfáltica Autoadhesiva Lisa 2 mm – 15 m (SPIDER P SA)', unit: 'rollos de 15 m', size: 13.5, roll: 15, sku: '2076', name: 'Lona Asfáltica Autoadhesiva Lisa 2 mm – 15 m (SPIDER P SA)', price: null }
    ],
    modes: [
      {
        id: 'rollos',
        label: 'Rollos de lona lisa',
        params: ['areaTecho', 'capasLona'],
        calc(inputs){
          const area = parseFloat(inputs.areaTecho || 0), capas = Math.max(parseFloat(inputs.capasLona || 1), 1);
          const pkg = pkgOf(inputs, 9), m2 = area * capas;
          return { area, capas, m2, pkg, units: ceilTo(m2 / pkg) };
        },
        describe(r){ const cap = r.capas === 1 ? '1 capa' : `${fmtAuto(r.capas)} capas`; return `${fmt(r.area,1)} m² × ${cap} = <b>${fmt(r.m2,1)} m²</b> ÷ <b>${fmt(r.pkg,1)} m² útiles por rollo</b>, redondeado hacia arriba.`; },
        footnote: 'Rollo de 1 × 10 m (10 m²) que rinde 9 m² útiles: el 10% restante se va en los traslapes. La Spider P SA Lisa 2 mm (2076) es de 1 × 15 m y rinde 13.5 m² útiles.',
        multiNote: (inputs) => `${fmtAuto(Math.max(parseFloat(inputs.capasLona || 1), 1))} capa(s)`
      }
    ]
  },

  md150: {
    id: 'md150',
    name: 'MD 150 (Desmoldante Plywood)',
    provider: 'Baumerk',
    sku: '1113',
    category: CATEGORIES.superficie.name,
    hasRange: false,
    unit: 'cubetas de 5 gal',
    defaultPres: 0,
    presentations: [
      { id: '5gl',  label: 'Cubeta 5 gl',  unit: 'cubetas de 5 gal',  size: 5,  gal: 5,  sku: '1113', name: 'MD 150 (Desmoldante Plywood) 5 gl', price: 3622.5, borrador: true },
      { id: '55gl', label: 'Tanque 55 gl', unit: 'tanques de 55 gal', size: 55, gal: 55, sku: '1115', name: 'MD 150 (Desmoldante Plywood) 55 gl', price: 27945.0, borrador: true }
    ],
    modes: [
      {
        id: 'plywood',
        label: 'Desmoldante para encofrados de plywood',
        params: ['areaMolde', 'aplicacionesMolde'],
        calc(inputs){
          const area = parseFloat(inputs.areaMolde || 0), n = Math.max(parseFloat(inputs.aplicacionesMolde || 1), 1);
          const pkg = pkgOf(inputs, 5), m2 = area * n, G = 3.78541;
          const L = m2 / 25;                                        // ficha: 1 L cubre 20–30 m² de molde (punto medio 25)
          const gal = L / G;
          return { area, n, m2, L, gal, units: ceilTo(gal / pkg), needKg: gal,
                   unitsRefMin: ceilTo(m2 / 30 / G / pkg), unitsRefMax: ceilTo(m2 / 20 / G / pkg) };
        },
        describe(r){ return `${fmt(r.area,1)} m² de molde × ${fmtAuto(r.n)} aplicación(es) = <b>${fmt(r.m2,1)} m²</b> ÷ 25 m² por litro = <b>${fmt(r.L,1)} L</b> (${fmt(r.gal,1)} gal), redondeado hacia arriba al envase.`; },
        footnote: 'Rendimiento de ficha: 1 litro cubre de 20 a 30 m² de molde (≈ 75–113 m² por galón; aquí 25 m² por litro): entre {min} y {max} envases según el tipo y la superficie del molde. Se aplica en capa delgada por inmersión, aspersión, rodillo o brocha.',
        multiNote: () => '1 L cada 25 m² de molde'
      }
    ]
  },

  cure_a: {
    id: 'cure_a',
    name: 'CURE A (Curador y Sellador de Hormigón)',
    provider: 'Baumerk',
    sku: '9010',
    category: CATEGORIES.curado.name,
    hasRange: false,
    unit: 'cubetas de 5 gal',
    defaultPres: 1,
    presentations: [
      { id: '1gl',  label: '1 galón',      unit: 'galones de 1 gal',  size: 1,  gal: 1,  sku: '9014', name: 'CURE A (Curador y Sellador de Hormigón) 1 gl', price: 724.5 },
      { id: '5gl',  label: 'Cubeta 5 gl',  unit: 'cubetas de 5 gal',  size: 5,  gal: 5,  sku: '9010', name: 'CURE A (Curador y Sellador de Hormigón) 5 gl', price: 2535.75 },
      { id: '55gl', label: 'Tanque 55 gl', unit: 'tanques de 55 gal', size: 55, gal: 55, sku: '9012', name: 'CURE A (Curador y Sellador de Hormigón) 55 gl', price: 24840.0 }
    ],
    modes: [
      {
        id: 'curado',
        label: 'Curado del concreto fresco (dos capas)',
        params: ['areaCurado'],
        calc(inputs){
          const area = parseFloat(inputs.areaCurado || 0), pkg = pkgOf(inputs, 5);
          const gal = area / 15.5;                                  // ficha: ~12–19 m² por galón en dos capas (punto medio 15.5)
          return { area, gal, units: ceilTo(gal / pkg), needKg: gal,
                   unitsRefMin: ceilTo(area / 19 / pkg), unitsRefMax: ceilTo(area / 12 / pkg) };
        },
        describe(r){ return `${fmt(r.area,1)} m² ÷ 15.5 m² por galón (dos capas) = <b>${fmt(r.gal,1)} gal</b>, redondeado hacia arriba al envase.`; },
        footnote: 'Rendimiento de ficha: 0.200–0.300 kg/m² en dos capas (≈ 12–19 m² por galón; aquí 15.5): entre {min} y {max} envases. Se aplica con pistola de aspersión o rodillo sobre el concreto fresco; al aire libre y en días ventosos, la segunda capa va dentro de las 6 horas siguientes.',
        multiNote: () => 'dos capas'
      }
    ]
  },

  fh_quartz: {
    id: 'fh_quartz',
    name: 'FH QUARTZ (Endurecedor en Polvo) 25 kg',
    provider: 'Baumerk',
    sku: '1111',
    category: CATEGORIES.pisos.name,
    hasRange: false,
    modeTitle: 'Uso',
    unit: 'sacos de 25 kg',
    modes: [
      {
        id: 'ligero',
        label: 'Tránsito ligero (4 kg/m²)',
        params: ['areaFH', 'margen'],
        calc(inputs){ const area = parseFloat(inputs.areaFH || 0); const r = conMargen(area * 4, 25, inputs); r.area = area; r.k = 4; return r; },
        describe(r){ return `${fmt(r.area,1)} m² × ${r.k} kg/m² = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'saco' : 'sacos'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`; },
        footnote: 'La ficha da 4–8 kg/m² según el uso previsto: aquí el mínimo (4 kg/m²) para tránsito ligero. Saco de 25 kg. Se espolvorea en dos pasadas (2/3 y 1/3) sobre el concreto fresco y se integra con el pulido.',
        multiNote: () => 'tránsito ligero'
      },
      {
        id: 'medio',
        label: 'Tránsito medio (6 kg/m²)',
        params: ['areaFH', 'margen'],
        calc(inputs){ const area = parseFloat(inputs.areaFH || 0); const r = conMargen(area * 6, 25, inputs); r.area = area; r.k = 6; return r; },
        describe(r){ return `${fmt(r.area,1)} m² × ${r.k} kg/m² = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'saco' : 'sacos'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`; },
        footnote: 'La ficha da 4–8 kg/m² según el uso previsto y no separa el tránsito medio: 6 kg/m² es el punto medio del rango, un valor de referencia. Saco de 25 kg.',
        multiNote: () => 'tránsito medio (6 kg/m², punto medio)'
      },
      {
        id: 'pesado',
        label: 'Tránsito pesado (8 kg/m²)',
        params: ['areaFH', 'margen'],
        calc(inputs){ const area = parseFloat(inputs.areaFH || 0); const r = conMargen(area * 8, 25, inputs); r.area = area; r.k = 8; return r; },
        describe(r){ return `${fmt(r.area,1)} m² × ${r.k} kg/m² = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'saco' : 'sacos'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`; },
        footnote: 'La ficha da 4–8 kg/m² según el uso previsto: aquí el máximo (8 kg/m²) para tránsito pesado, industrial, rampas y zonas de carga. Saco de 25 kg.',
        multiNote: () => 'tránsito pesado'
      },
      {
        id: 'claros',
        label: 'Colores claros (mínimo 7 kg/m²)',
        params: ['areaFH', 'margen'],
        calc(inputs){ const area = parseFloat(inputs.areaFH || 0); const r = conMargen(area * 7, 25, inputs); r.area = area; r.k = 7; return r; },
        describe(r){ return `${fmt(r.area,1)} m² × ${r.k} kg/m² = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'saco' : 'sacos'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`; },
        footnote: 'Según la ficha, en colores claros el consumo mínimo es de 7 kg/m². Si además el tránsito es pesado, usa el uso “Tránsito pesado” (8 kg/m²). Saco de 25 kg.',
        multiNote: () => 'colores claros (mín. 7 kg/m²)'
      }
    ]
  },

  brod: {
    id: 'brod',
    name: 'B-ROD Backer Rod (Relleno de Juntas) (todas las referencias)',
    provider: 'Baumerk',
    sku: '—',
    category: CATEGORIES.juntas.name,
    hasRange: false,
    unit: 'paquetes de 6 m',
    presLabel: 'Referencia',
    defaultPres: 2,
    // Todas las referencias de B-ROD se calculan igual: 1 m de cordón por cada metro de junta.
    // size = metros por empaque (paquete de 6 m, o por metro cortado del rollo completo). group = diámetro (la comparación de precios es solo dentro del mismo diámetro).
    presentations: [
      { id: '3021', label: 'Ø 6 mm · Paquete 6 m', unit: 'paquetes de 6 m', size: 6, group: 6, dia: 6, sku: '3021', name: 'B-ROD Backer Rod (Relleno de Juntas) 6 mm (1/4") – Paquete 6 m', price: 82.8 },
      { id: '3017', label: 'Ø 6 mm · Por metro (rollo completo de 2,000 m)', unit: 'metros', size: 1, group: 6, dia: 6, sku: '3017', name: 'B-ROD Backer Rod (Relleno de Juntas) 6 mm (1/4") – Paquete Completo 2,000 m', price: 13.8 },
      { id: '3022', label: 'Ø 10 mm · Paquete 6 m', unit: 'paquetes de 6 m', size: 6, group: 10, dia: 10, sku: '3022', name: 'B-ROD Backer Rod (Relleno de Juntas) 10 mm (3/8") – Paquete 6 m', price: 93.15 },
      { id: '3018', label: 'Ø 10 mm · Por metro (rollo completo de 1,000 m)', unit: 'metros', size: 1, group: 10, dia: 10, sku: '3018', name: 'B-ROD Backer Rod (Relleno de Juntas) 10 mm (3/8") – Paquete Completo 1,000 m', price: 15.52 },
      { id: '3023', label: 'Ø 15 mm · Paquete 6 m', unit: 'paquetes de 6 m', size: 6, group: 15, dia: 15, sku: '3023', name: 'B-ROD Backer Rod (Relleno de Juntas) 15 mm (5/8") – Paquete 6 m', price: 186.3 },
      { id: '3019', label: 'Ø 15 mm · Por metro (rollo completo de 500 m)', unit: 'metros', size: 1, group: 15, dia: 15, sku: '3019', name: 'B-ROD Backer Rod (Relleno de Juntas) 15 mm (5/8") – Paquete Completo 500 m', price: 31.05 },
      { id: '3024', label: 'Ø 20 mm · Paquete 6 m', unit: 'paquetes de 6 m', size: 6, group: 20, dia: 20, sku: '3024', name: 'B-ROD Backer Rod (Relleno de Juntas) 20 mm (3/4") – Paquete 6 m', price: 279.45 },
      { id: '3020', label: 'Ø 20 mm · Por metro (rollo completo de 270 m)', unit: 'metros', size: 1, group: 20, dia: 20, sku: '3020', name: 'B-ROD Backer Rod (Relleno de Juntas) 20 mm (3/4") – Paquete Completo 270 m', price: 46.58 },
      { id: '3026', label: 'Ø 25 mm · Paquete 6 m', unit: 'paquetes de 6 m', size: 6, group: 25, dia: 25, sku: '3026', name: 'B-ROD Backer Rod (Relleno de Juntas) 25 mm (1") – Paquete 6 m', price: 403.65 },
      { id: '3025', label: 'Ø 25 mm · Por metro (rollo completo de 180 m)', unit: 'metros', size: 1, group: 25, dia: 25, sku: '3025', name: 'B-ROD Backer Rod (Relleno de Juntas) 25 mm (1") – Paquete Completo 180 m', price: 69.96 }
    ],
    keywords: ['backer rod', 'b-rod', 'b rod', 'cordón', 'cordon', 'respaldo', 'relleno de juntas', 'espuma'],
    sameCalcNote: 'Todas las referencias de B-ROD se calculan igual: 1 metro de cordón por cada metro de junta.',
    modes: [
      {
        id: 'cordon',
        label: 'Cordón de respaldo para juntas',
        params: ['longitudJunta', 'anchoJunta'],
        calc(inputs){
          const len = parseFloat(inputs.longitudJunta || 0), w = parseFloat(inputs.anchoJunta || 0);
          const pkg = pkgOf(inputs, 6);
          const pr = inputs._pres;
          return { len, w, pkg, dia: pr ? pr.dia : null, units: ceilTo(len / pkg), needKg: len };
        },
        describe(r){
          const MAX = [[6, 4.5], [10, 7.5], [15, 11.5], [20, 15], [25, 19]];       // regla del 30% (ficha): ancho máximo de junta por diámetro
          const rec = MAX.find(x => r.w <= x[1]);
          let t = `${fmt(r.len,1)} m de junta × 1 m de cordón por metro = <b>${fmt(r.len,1)} m</b> de B-ROD.`;
          if (r.w > 0){
            if (!rec) t += warnTxt(`Con una junta de ${fmtAuto(r.w)} mm el B-ROD de 25 mm (hasta 19 mm de junta) no alcanza: consulta al asesor.`);
            else if (r.dia && r.dia !== rec[0]) t += warnTxt(`Para una junta de ${fmtAuto(r.w)} mm, la regla del 30% indica B-ROD de ${rec[0]} mm; elegiste Ø ${r.dia} mm.`);
            else t += ` Para una junta de ${fmtAuto(r.w)} mm, la regla del 30% indica B-ROD de ${rec[0]} mm.`;
          }
          return t;
        },
        footnote: 'Consumo de ficha: 1 metro lineal de B-ROD por cada metro lineal de junta. Se elige un diámetro al menos 30% mayor que el ancho de la junta (6 mm hasta 4.5 mm de junta; 10 mm hasta 7.5; 15 mm hasta 11.5; 20 mm hasta 15; 25 mm hasta 19) y se coloca comprimido, antes del sellador. Las referencias “Por metro” son el rollo completo vendido por metro cortado.',
        multiNote: () => '1 m de cordón por metro de junta'
      }
    ]
  },

  waterstop: {
    id: 'waterstop',
    name: 'Junta Waterstop Tipo O (Junta Hidráulica de PVC) 15 cm × 3 mm – Rollo 25 m',
    provider: 'Baumerk',
    sku: '6011',
    category: CATEGORIES.juntas.name,
    hasRange: false,
    unit: 'rollos de 25 m',
    modes: [
      {
        id: 'junta',
        label: 'Junta de construcción o expansión embebida en el concreto',
        params: ['longitudJunta'],
        calc(inputs){ const len = parseFloat(inputs.longitudJunta || 0); return { len, units: ceilTo(len / 25) }; },
        describe(r){ return `${fmt(r.len,1)} m de junta ÷ 25 m por rollo, redondeado hacia arriba.`; },
        footnote: 'Rollo de 25 m (Tipo O, 15 cm × 3 mm). La ficha no da un consumo por traslape: los empalmes se unen por termofusión, así que considera algo de recorte en empalmes, esquinas e intersecciones.',
        multiNote: () => '1 m por metro de junta'
      }
    ]
  },

  swellband: {
    id: 'swellband',
    name: 'SWELLBAND Banda de Expansión Bentonita (Sello Hidroexpansivo de Juntas)',
    provider: 'Baumerk',
    sku: '6013',
    category: CATEGORIES.juntas.name,
    hasRange: false,
    unit: 'rollos de 20 m',
    presLabel: 'Sección y largo',
    defaultPres: 0,
    // group = sección: la comparación de precios es solo entre rollos de la misma sección
    presentations: [
      { id: '6013', label: '5 × 20 mm · rollo de 20 m', unit: 'rollos de 20 m', size: 20, group: '5x20',  sku: '6013', name: 'SWELLBAND Banda de Expansión Bentonita (Sello Hidroexpansivo de Juntas) 5 × 20 mm – 20 m', price: 5692.5 },
      { id: '6009', label: '5 × 20 mm · rollo de 15 m', unit: 'rollos de 15 m', size: 15, group: '5x20',  sku: '6009', name: 'SWELLBAND Banda de Expansión Bentonita (Sello Hidroexpansivo de Juntas) 5 × 20 mm – 15 m', price: 6934.5 },
      { id: '6010', label: '10 × 20 mm · rollo de 10 m', unit: 'rollos de 10 m', size: 10, group: '10x20', sku: '6010', name: 'SWELLBAND Banda de Expansión Bentonita (Sello Hidroexpansivo de Juntas) 10 × 20 mm – 10 m', price: 5175.0 }
    ],
    modes: [
      {
        id: 'junta',
        label: 'Junta de construcción de concreto vaciado en sitio',
        params: ['longitudJunta'],
        calc(inputs){ const len = parseFloat(inputs.longitudJunta || 0); const pkg = pkgOf(inputs, 20); return { len, pkg, units: ceilTo(len / pkg), needKg: len }; },
        describe(r){ return `${fmt(r.len,1)} m de junta × 1 m de banda por metro ÷ ${fmt(r.pkg,0)} m por rollo, redondeado hacia arriba.`; },
        footnote: 'Consumo de ficha: 1 metro lineal de SWELLBAND por cada metro lineal de junta. Los empalmes se colocan a tope, sin traslapar. No es apto para juntas de elementos prefabricados.',
        multiNote: () => '1 m por metro de junta'
      }
    ]
  },

  pumast600: {
    id: 'pumast600',
    name: 'PUMAST 600 (Sellador de Poliuretano para Juntas) Gris 600 ml',
    provider: 'Baumerk',
    sku: '8002',
    category: CATEGORIES.juntas.name,
    hasRange: false,
    modeTitle: 'Uso',
    unit: 'salchichones de 600 ml',
    modes: [
      {
        id: 'dimensiones',
        label: 'Junta con ancho y profundidad conocidos',
        params: ['longitudJunta', 'anchoJunta', 'profundidadJunta', 'margen'],
        calc(inputs){
          const len = parseFloat(inputs.longitudJunta || 0), w = parseFloat(inputs.anchoJunta || 0), d = parseFloat(inputs.profundidadJunta || 0);
          const L = len * w * d / 1000;                                 // litros de junta
          const r = conMargen(L, 0.6, inputs);
          r.len = len; r.w = w; r.d = d; r.L = L; return r;
        },
        describe(r){
          let t = `${fmt(r.len,1)} m × ${fmtAuto(r.w)} mm × ${fmtAuto(r.d)} mm = <b>${fmt(r.L,2)} L</b> de junta · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'salchichón' : 'salchichones'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`;
          if (r.w > 25) t += warnTxt('La ficha limita el ancho máximo de la junta a 25 mm.');
          if (r.w > 0 && r.w < 5) t += warnTxt('El ancho de la junta no debe ser menor de 5 mm.');
          if (r.d > 0 && r.d < 6) t += warnTxt('La profundidad mínima es de 6 mm.');
          if (r.w > 0 && r.d > r.w / 2 + 0.01) t += warnTxt(`La relación recomendada es ancho = 2 × profundidad: para una junta de ${fmtAuto(r.w)} mm, la profundidad ideal es ${fmtAuto(Math.max(r.w / 2, 6))} mm (con más, el sellador se gasta de más).`);
          return t;
        },
        footnote: 'Consumo de ficha: 1.15 kg por litro de junta; un salchichón de 600 ml rinde ≈ 6 m de una junta de 10 × 10 mm. Relación recomendada: ancho = 2 × profundidad. Una vez abierto, conviene usar el envase dentro de las 24 horas, por eso el margen.',
        multiNote: () => 'ancho y profundidad'
      },
      {
        id: 'proporcion',
        label: 'Solo el ancho (profundidad recomendada: la mitad)',
        params: ['longitudJunta', 'anchoJunta', 'margen'],
        calc(inputs){
          const len = parseFloat(inputs.longitudJunta || 0), w = parseFloat(inputs.anchoJunta || 0);
          const d = Math.max(w / 2, 6);                                 // ancho = 2 × profundidad, mínimo 6 mm
          const L = len * w * d / 1000;
          const r = conMargen(L, 0.6, inputs);
          r.len = len; r.w = w; r.d = d; r.L = L; return r;
        },
        describe(r){
          let t = `${fmt(r.len,1)} m × ${fmtAuto(r.w)} mm × ${fmtAuto(r.d)} mm (profundidad = ancho ÷ 2, mín. 6 mm) = <b>${fmt(r.L,2)} L</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'salchichón' : 'salchichones'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`;
          if (r.w > 25) t += warnTxt('La ficha limita el ancho máximo de la junta a 25 mm.');
          if (r.w > 0 && r.w < 5) t += warnTxt('El ancho de la junta no debe ser menor de 5 mm.');
          return t;
        },
        footnote: 'Se calcula con la relación recomendada por la ficha (ancho = 2 × profundidad, con profundidad mínima de 6 mm). Consumo: 1.15 kg por litro de junta; un salchichón de 600 ml rinde ≈ 6 m de una junta de 10 × 10 mm.',
        multiNote: () => 'profundidad = ancho ÷ 2'
      }
    ]
  },

  drain_b: {
    id: 'drain_b',
    name: 'DRAIN-B (Lámina de Drenaje y Protección) 2 × 20 m',
    provider: 'Baumerk',
    sku: '6008',
    category: CATEGORIES.drenaje.name,
    hasRange: false,
    unit: 'rollos de 2 × 20 m',
    modes: [
      {
        id: 'muro',
        label: 'Protección de cimentaciones y muros contra terreno',
        params: ['areaDrenaje'],
        calc(inputs){ const area = parseFloat(inputs.areaDrenaje || 0); return { area, units: ceilTo(area / 36) }; },
        describe(r){ return `${fmt(r.area,1)} m² ÷ <b>36 m² útiles por rollo</b> (40 m², menos el traslape de 20 cm), redondeado hacia arriba.`; },
        footnote: 'Rollo de 2 × 20 m (40 m²). La ficha pide un traslape mínimo de 20 cm en las uniones: sobre un ancho de 2 m queda un ancho útil de 1.8 m, es decir 36 m² por rollo (estimado con el traslape en el sentido del largo). Se coloca con los hoyuelos hacia el muro, 15 cm por encima de la impermeabilización, fijado cada 20 cm o con PROFILE AL.',
        multiNote: () => '36 m² útiles por rollo'
      }
    ]
  },

  polyfond_kit: {
    id: 'polyfond_kit',
    name: 'POLYFOND KIT (Lámina de Drenaje y Protección) 2 × 20 m',
    provider: 'Polyglass',
    sku: '6015',
    category: CATEGORIES.drenaje.name,
    hasRange: false,
    unit: 'rollos de 2 × 20 m',
    modes: [
      {
        id: 'muro',
        label: 'Protección de impermeabilización en estructuras subterráneas',
        params: ['areaDrenaje'],
        calc(inputs){ const area = parseFloat(inputs.areaDrenaje || 0); return { area, units: ceilTo(area / 36) }; },
        describe(r){ return `${fmt(r.area,1)} m² ÷ <b>36 m² útiles por rollo</b> (40 m², menos el traslape de 20 cm), redondeado hacia arriba.`; },
        footnote: 'Rollo de 2 × 20 m (40 m²). La ficha pide solapar los bordes unos 20 cm: sobre un ancho de 2 m queda un ancho útil de 1.8 m, es decir 36 m² por rollo (estimado con el traslape en el sentido del largo). Se coloca con la cara lisa hacia la impermeabilización y se fija arriba con un perfil y sellador.',
        multiNote: () => '36 m² útiles por rollo'
      }
    ]
  },

  profile_al: {
    id: 'profile_al',
    name: 'PROFILE AL (Perfil de Aluminio para Lámina de Drenaje) 3 m',
    provider: 'Baumerk',
    sku: '6020',
    category: CATEGORIES.drenaje.name,
    hasRange: false,
    unit: 'perfiles de 3 m',
    modes: [
      {
        id: 'remate',
        label: 'Remate del borde superior de la lámina de drenaje',
        params: ['longBordeDrenaje'],
        calc(inputs){ const len = parseFloat(inputs.longBordeDrenaje || 0); return { len, units: ceilTo(len / 3) }; },
        describe(r){ return `${fmt(r.len,1)} m de borde superior ÷ 3 m por perfil, redondeado hacia arriba.`; },
        footnote: 'Consumo de ficha: 1 metro lineal de perfil por cada metro lineal de borde superior de la lámina (un perfil de 3 m cubre 3 m). Se fija con tornillos y tacos (o remaches) y se sella con un sellador elástico como PUMAST 600.',
        multiNote: () => '1 m por metro de borde'
      }
    ]
  },

  proflex: {
    id: 'proflex',
    name: 'PROFLEX (Relleno Epóxico para Juntas de Pisos) Kit A + B 1 gl',
    provider: 'Dayton Superior',
    sku: '8015',
    category: CATEGORIES.juntas.name,
    hasRange: false,
    unit: 'kits (1 galón mezclado)',
    params: ['longitudJunta', 'anchoJunta', 'profundidadJunta'],
    calc(inputs){
      const longitud = parseFloat(inputs.longitudJunta || 0); // m
      const ancho = parseFloat(inputs.anchoJunta || 0); // mm
      const profundidad = parseFloat(inputs.profundidadJunta || 0); // mm
      const volumenL = (longitud * ancho * profundidad) / 1000; // L
      const galones = volumenL / 3.785;
      return { volumenL, galones, units: ceilTo(galones) };
    }
  },

  /* ---------------------------------------------------------
     SISTEMA DE PISO EPÓXICO (Baumerk)
     Todos comparten el parámetro "area"; cada uno aplica su
     propia fórmula + redondeo al empaque + margen de 10%
     (mermas/bordes), igual que el cotizador Excel original.
     --------------------------------------------------------- */
  repamerk_301: {
    id: 'repamerk_301',
    name: 'REPAMERK 301 (Mortero Cementicio de Reparación Estructural con Fibras) 25 kg',
    provider: 'Baumerk',
    sku: '1117',
    category: CATEGORIES.reparaciones.name,
    hasRange: false,
    modeTitle: 'Uso',
    unit: 'sacos de 25 kg',
    modes: [
      {
        id: 'piso_epoxico',
        label: 'Reparación previa a un piso epóxico (solo el área con daños)',
        params: ['area', 'pctDanos'],
        calc(inputs){
          const area = parseFloat(inputs.area || 0), danos = parseFloat(inputs.pctDanos || 0) / 100;
          const r = conMargenExcel(area * danos * 19.2, 25);   // 19.2 kg/m² a 10 mm
          r.area = area; r.danos = danos * 100; return r;
        },
        describe(r){ return `${fmt(r.area,0)} m² × ${fmt(r.danos,0)}% con daños × 19.2 kg/m² (a 10 mm) = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'saco' : 'sacos'}, con 10% de margen <b>${r.units}</b>.`; },
        footnote: 'Cálculo del cotizador de piso epóxico: se repara solo el porcentaje de área dañada a 10 mm de espesor (19.2 kg/m²). Margen fijo de 10% con doble redondeo, igual que el Excel.',
        multiNote: () => 'reparación previa al piso epóxico'
      },
      {
        id: 'elementos',
        label: 'Reparación de vigas, columnas, losas y muros (por área y espesor)',
        params: ['areaRepamerk', 'espesorRepamerk', 'margen'],
        calc(inputs){
          const area = parseFloat(inputs.areaRepamerk || 0), esp = parseFloat(inputs.espesorRepamerk || 0);
          const r = conMargen(area * esp * 1.92, 25, inputs);   // 19.2 kg/m² por 10 mm = 1.92 kg/m² por mm
          r.area = area; r.esp = esp; return r;
        },
        describe(r){
          const w = (r.esp < 10 || r.esp > 40) ? warnTxt('La ficha permite de 10 a 40 mm en una sola capa; si necesitas más, aplica una segunda capa a las 24 horas.') : '';
          return `${fmt(r.area,1)} m² × ${fmt(r.esp,0)} mm × 1.92 kg/m²·mm = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'saco' : 'sacos'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.${w}`;
        },
        footnote: 'Consumo de ficha: ~19.2 kg/m² para 10 mm de espesor (1.92 kg/m² por mm). Espesor recomendado de 10 a 40 mm por capa. Saco de 25 kg que se mezcla con máximo 4 L de agua.',
        multiNote: () => 'reparación por área y espesor'
      },
      {
        id: 'huecos',
        label: 'Relleno de huecos de varillas y conos (tie-rod)',
        params: ['nRepamerkHoyo', 'dRepamerkHoyo', 'profRepamerkHoyo', 'margen'],
        calc(inputs){
          const n = parseFloat(inputs.nRepamerkHoyo || 0), d = parseFloat(inputs.dRepamerkHoyo || 0), prof = parseFloat(inputs.profRepamerkHoyo || 0);
          const L = n * Math.PI / 4 * d * d * prof / 1e6;     // mm³ → L
          const r = conMargen(L * 1.92, 25, inputs);          // 1.92 kg de polvo por litro de mortero (19.2 kg/m² a 10 mm)
          r.L = L; r.n = n; return r;
        },
        describe(r){ return `${fmt(r.n,0)} huecos = <b>${fmt(r.L,2)} L</b> × 1.92 kg/L = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'saco' : 'sacos'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`; },
        footnote: 'Estimado geométrico: volumen de los huecos × 1.92 kg de polvo por litro (derivado del consumo de ficha, 19.2 kg/m² a 10 mm). Para pocos huecos, un saco rinde para muchos.',
        multiNote: () => 'huecos de varillas y conos'
      }
    ]
  },


  sbr_latex: {
    id: 'sbr_latex',
    name: 'SBR LÁTEX 35-40 (Aditivo Adherente e Impermeabilizante)',
    provider: 'Baumerk',
    sku: '9016',
    category: CATEGORIES.aditivos.name,
    hasRange: false,
    modeTitle: 'Uso',
    unit: 'cubetas de 5 gal',
    // Mismo producto en 3 envases (galón, 5 galones y 55 galones). Nombres, SKU y precios: tienda en línea (Shopify).
    defaultPres: 1,
    presentations: [
      { id: '1gl',  label: '1 galón',      unit: 'galones de 1 gal',  size: SBR_KG_POR_GAL,      gal: 1,  sku: '9011', name: 'SBR LÁTEX 35-40 (Aditivo Adherente e Impermeabilizante) 1 gl', price: 931.5 },
      { id: '5gl',  label: 'Cubeta 5 gl',  unit: 'cubetas de 5 gal',  size: SBR_PKG_KG,          gal: 5,  sku: '9016', name: 'SBR LÁTEX 35-40 (Aditivo Adherente e Impermeabilizante) 5 gl', price: 3311.99 },
      { id: '55gl', label: 'Tanque 55 gl', unit: 'tanques de 55 gal', size: 55 * SBR_KG_POR_GAL, gal: 55, sku: '9013', name: 'SBR LÁTEX 35-40 (Aditivo Adherente e Impermeabilizante) 55 gl', price: 33120.0 }
    ],
    modes: [
      {
        id: 'puente',
        label: 'Puente de adherencia (brocha, rodillo o spray)',
        params: ['area'],
        calc(inputs){
          const area = parseFloat(inputs.area || 0);
          const r = conMargenExcel(area * 0.175, pkgOf(inputs, SBR_PKG_KG));        // ficha: 150–200 g/m² (punto medio 175)
          r.unitsRefMin = conMargenExcel(area * 0.150, pkgOf(inputs, SBR_PKG_KG)).units;
          r.unitsRefMax = conMargenExcel(area * 0.200, pkgOf(inputs, SBR_PKG_KG)).units;
          r.area = area; return r;
        },
        describe(r){ return `${fmt(r.area,0)} m² × 175 g/m² = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.unitNet || 'cubetas'}, con 10% de margen <b>${r.units}</b>.`; },
        footnote: 'Consumo de ficha: 150–200 g/m² (aquí 175): {rango} cubetas con margen. El material nuevo se coloca mientras el látex aún está húmedo. Margen fijo de 10% con doble redondeo, igual que el cotizador de piso epóxico. Cubeta de 5 gal ≈ 20.4 kg (densidad 1.08 kg/L).',
        multiNote: () => 'puente de adherencia'
      },
      {
        id: 'panete',
        label: 'Mortero de pañete (repello)',
        params: ['m3SbrPanete', 'margen'],
        calc(inputs){ const m3 = parseFloat(inputs.m3SbrPanete || 0); const r = conMargen(m3 * 5, pkgOf(inputs, SBR_PKG_KG), inputs); r.m3 = m3; return r; },
        describe(r){ return `<b>${fmt(r.m3,2)} m³</b> de arena × 5 kg/m³ = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.unitNet || 'cubetas'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`; },
        footnote: 'Receta de ficha por m³ de arena de río lavada: 350 kg de cemento + 120 kg de agua con 5 kg de SBR Látex 35-40 (mezclados aparte y vertidos sobre el polvo).',
        multiNote: () => 'mortero de pañete'
      },
      {
        id: 'lechada',
        label: 'Lechada',
        params: ['m3SbrLechada', 'margen'],
        calc(inputs){ const m3 = parseFloat(inputs.m3SbrLechada || 0); const r = conMargen(m3 * 4, pkgOf(inputs, SBR_PKG_KG), inputs); r.m3 = m3; return r; },
        describe(r){ return `<b>${fmt(r.m3,2)} m³</b> de arena × 4 kg/m³ = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.unitNet || 'cubetas'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`; },
        footnote: 'Receta de ficha por m³ de arena de río lavada: 350 kg de cemento + 110 kg de agua con 4 kg de SBR Látex 35-40. Se aplica sobre la superficie ya imprimada.',
        multiNote: () => 'lechada'
      },
      {
        id: 'revestimiento',
        label: 'Mortero de revestimiento (colocación de piso)',
        params: ['m3SbrRev', 'margen'],
        calc(inputs){ const m3 = parseFloat(inputs.m3SbrRev || 0); const r = conMargen(m3 * 3, pkgOf(inputs, SBR_PKG_KG), inputs); r.m3 = m3; return r; },
        describe(r){ return `<b>${fmt(r.m3,2)} m³</b> de agregado × 3 kg/m³ = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.unitNet || 'cubetas'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`; },
        footnote: 'Receta de ficha por m³ de agregado: 250 kg de cemento + 3 kg de SBR Látex 35-40, con agua hasta obtener una mezcla espesa. La mezcla y la colocación del piso se hacen en conjunto.',
        multiNote: () => 'mortero de revestimiento'
      },
      {
        id: 'espolvoreo',
        label: 'Mortero de espolvoreo (shake)',
        params: ['m3SbrShake', 'margen'],
        calc(inputs){ const m3 = parseFloat(inputs.m3SbrShake || 0); const r = conMargen(m3 * 10, pkgOf(inputs, SBR_PKG_KG), inputs); r.m3 = m3; return r; },
        describe(r){ return `<b>${fmt(r.m3,2)} m³</b> de arena × 10 kg/m³ = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.unitNet || 'cubetas'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`; },
        footnote: 'Receta de ficha por m³ de arena de río lavada: 350 kg de cemento + 10 kg de SBR Látex 35-40, con agua hasta obtener una mezcla espesa. Se aplica con equipo esparcidor; tránsito peatonal a las 24 horas.',
        multiNote: () => 'mortero de espolvoreo'
      },
      {
        id: 'concreto_fibermix',
        label: 'Concreto con Fibermix (trabajabilidad y acabado)',
        params: ['volumen', 'margen'],
        calc(inputs){
          const m3 = parseFloat(inputs.volumen || 0);
          const r = conMargen(m3 * SBR_KG_POR_GAL, pkgOf(inputs, SBR_PKG_KG), inputs);   // ~1 galón por m³ de concreto
          r.m3 = m3; r.gal = m3; return r;
        },
        describe(r){ return `<b>${fmt(r.m3,1)} m³</b> de concreto × ~1 gal/m³ = <b>${fmt(r.gal,0)} gal</b> · neto <b>${r.netUnits}</b> ${r.unitNet || 'cubetas de 5 gal'}, con ${fmt(r.margenPct,0)}% de margen <b>${r.units}</b>.`; },
        footnote: 'Recomendación de la ficha de Fibermix: ~1 galón de SBR Látex 35-40 por m³ de concreto mejora la adherencia, la flexibilidad, el manejo y el acabado, y recupera trabajabilidad sin agregar agua. Es opcional.',
        multiNote: () => 'concreto con Fibermix (~1 gal/m³)'
      }
    ]
  },


  selfing_600: {
    id: 'selfing_600',
    name: 'SELFING 600 (Mortero Autonivelante) 25 kg',
    provider: 'Baumerk',
    sku: '1108',
    category: CATEGORIES.pisos.name,
    hasRange: false,
    unit: 'sacos de 25 kg',
    packageKg: 25,
    marginPct: 0.10,
    params: ['area', 'espesorSelfing'],
    calc(inputs){
      const area = parseFloat(inputs.area || 0);
      const espesor = parseFloat(inputs.espesorSelfing || 0);
      const kg = area * espesor * 1.70;
      const netUnits = ceilTo(kg / this.packageKg);
      const units = ceilTo(netUnits * (1 + this.marginPct));
      return { kg, netUnits, units };
    }
  },

  epox_pr_100: {
    id: 'epox_pr_100',
    name: 'EPOX PR 100 (Imprimante Epóxico Sin Solventes) 25 kg',
    provider: 'Baumerk',
    sku: '8012',
    category: CATEGORIES.pisos.name,
    hasRange: false,
    modeTitle: 'Uso',
    unit: 'sets de 25 kg',
    modes: [
      {
        id: 'imprimante_normal',
        label: 'Imprimante · superficie normal (0.30 kg/m²)',
        params: ['area'],
        calc(inputs){ const area = parseFloat(inputs.area || 0); const r = conMargenExcel(area * 0.30, 25); r.area = area; return r; },
        describe(r){ return `${fmt(r.area,0)} m² × 0.30 kg/m² = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'set' : 'sets'}, con 10% de margen <b>${r.units}</b>.`; },
        footnote: 'La ficha da 0.150–0.500 kg/m² según la porosidad y la condición de la superficie. 0.30 kg/m² es el valor del cotizador de piso epóxico. Set de 25 kg (17 kg de A + 8 kg de B). Margen fijo de 10% con doble redondeo.',
        multiNote: () => 'imprimante · superficie normal'
      },
      {
        id: 'imprimante_poco',
        label: 'Imprimante · superficie poco porosa (0.15 kg/m²)',
        params: ['area'],
        calc(inputs){ const area = parseFloat(inputs.area || 0); const r = conMargenExcel(area * 0.15, 25); r.area = area; return r; },
        describe(r){ return `${fmt(r.area,0)} m² × 0.15 kg/m² = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'set' : 'sets'}, con 10% de margen <b>${r.units}</b>.`; },
        footnote: 'Mínimo de la ficha (0.150 kg/m²), para concreto denso y de baja absorción. Set de 25 kg. Margen fijo de 10% con doble redondeo.',
        multiNote: () => 'imprimante · poco porosa'
      },
      {
        id: 'imprimante_muy',
        label: 'Imprimante · superficie muy porosa o deteriorada (0.50 kg/m²)',
        params: ['area'],
        calc(inputs){ const area = parseFloat(inputs.area || 0); const r = conMargenExcel(area * 0.50, 25); r.area = area; return r; },
        describe(r){ return `${fmt(r.area,0)} m² × 0.50 kg/m² = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'set' : 'sets'}, con 10% de margen <b>${r.units}</b>.`; },
        footnote: 'Máximo de la ficha (0.500 kg/m²), para superficies muy porosas o deterioradas que absorben mucho. Set de 25 kg. Margen fijo de 10% con doble redondeo.',
        multiNote: () => 'imprimante · muy porosa'
      },
      {
        id: 'mortero',
        label: 'Mortero epóxico de reparación (mezclado con arena de cuarzo)',
        params: [],
        calc(){ return { units: null, blocked: true }; },
        describe(){ return 'La ficha permite mezclar EPOX PR 100 con arena de cuarzo o agregado fino para bacheos y resanes, pero <b>no indica la proporción resina : arena</b>, así que no se puede calcular con certeza.'; },
        footnote: 'Pide la proporción al asesor técnico o al fabricante (Baumerk) antes de cotizar este uso. Para reparaciones estructurales considera Epox 310.',
        multiNote: () => 'requiere proporción del fabricante',
        blockMsg: 'Sin proporción en la ficha: consultar al asesor.',
        blockLabel: 'consultar al asesor'
      }
    ]
  },


  epox_sl_800: {
    id: 'epox_sl_800',
    name: 'EPOX SL 800 (Recubrimiento Epóxico Autonivelante) Gris 15 kg',
    provider: 'Baumerk',
    sku: '8013',
    category: CATEGORIES.pisos.name,
    hasRange: false,
    modeTitle: 'Uso',
    unit: 'sets de 15 kg',
    modes: [
      {
        id: 'autonivelante',
        label: 'Acabado epóxico autonivelante',
        params: ['area', 'espesorEpoxSL800'],
        calc(inputs){
          const area = parseFloat(inputs.area || 0), esp = parseFloat(inputs.espesorEpoxSL800 || 0);
          const r = conMargenExcel(area * esp * 1.55, 15);          // ficha: 1.50–1.60 kg/m² por mm (punto medio)
          r.unitsRefMin = conMargenExcel(area * esp * 1.50, 15).units; r.unitsRefMax = conMargenExcel(area * esp * 1.60, 15).units;
          r.area = area; r.esp = esp; return r;
        },
        describe(r){ return `${fmt(r.area,0)} m² × ${fmt(r.esp,1)} mm × 1.55 kg/m²·mm = <b>${fmt(r.kg,1)} kg</b> · neto <b>${r.netUnits}</b> ${r.netUnits === 1 ? 'set' : 'sets'}, con 10% de margen <b>${r.units}</b>.`; },
        footnote: 'Consumo de ficha: 1.50–1.60 kg/m² por mm de espesor (aquí 1.55): entre {min} y {max} sets con margen. Se aplica sobre superficie imprimada con Epox PR 100. Set de 15 kg (12 kg de A + 3 kg de B). Margen fijo de 10% con doble redondeo.',
        multiNote: () => 'acabado autonivelante'
      },
      {
        id: 'con_agregado',
        label: 'Con agregado (antideslizante o mayor espesor)',
        params: [],
        calc(){ return { units: null, blocked: true }; },
        describe(){ return 'La ficha permite añadir agregado al EPOX SL 800 para lograr una textura antideslizante o un mayor espesor, pero <b>no indica la proporción</b>, así que no se puede calcular con certeza.'; },
        footnote: 'Pide la proporción al asesor técnico o al fabricante (Baumerk) antes de cotizar este uso.',
        multiNote: () => 'requiere proporción del fabricante',
        blockMsg: 'Sin proporción en la ficha: consultar al asesor.',
        blockLabel: 'consultar al asesor'
      }
    ]
  },


};

/* =========================================================
   SISTEMAS PREDEFINIDOS (bundles)
   Atajo que preselecciona un grupo fijo de productos en el
   flujo "varios productos", para proyectos tipo que siempre
   usan la misma combinación.
   ========================================================= */
const SYSTEMS = {
  piso_epoxico_baumerk: {
    id: 'piso_epoxico_baumerk',
    name: 'Sistema de Piso Epóxico (Baumerk)',
    description: 'Repamerk 301 · SBR Látex 35-40 · Selfing 600 · Epox PR 100 · Epox SL 800',
    productIds: ['repamerk_301', 'sbr_latex', 'selfing_600', 'epox_pr_100', 'epox_sl_800']
  },
  techo_granulada: {
    id: 'techo_granulada',
    name: 'Sistema de Techo con Lona Granulada',
    description: 'Primer Asfáltico Baliu (cubeta o tanque) · Lona asfáltica granulada (tú eliges la referencia) · Cemento Plástico Baliu (galón o cubeta)',
    productIds: ['primer_baliu', 'lona_granulada', 'cemento_plastico_baliu']
  },
  techo_lisa: {
    id: 'techo_lisa',
    name: 'Sistema de Techo con Lona Lisa y Pintura de Aluminio',
    description: 'Primer Asfáltico Baliu (cubeta o tanque) · Lona asfáltica lisa (tú eliges la referencia) · Cemento Plástico Baliu (galón o cubeta) · Pintura de Aluminio (Baliu o Rooflex)',
    productIds: ['primer_baliu', 'lona_lisa', 'cemento_plastico_baliu', 'pintura_aluminio']
  }
};

/* Helpers para productos con múltiples modos de cálculo (ej: Powlog) */
function getProductParams(product, modeIndex){
  if (product.modes) return product.modes[modeIndex != null ? modeIndex : 0].params;
  return product.params;
}
function getProductCalc(product, modeIndex){
  if (product.modes) return product.modes[modeIndex != null ? modeIndex : 0].calc;
  return product.calc.bind(product);
}
/* ======== FIN DATOS ======== */

/* Lista pública de SKU que están en la calculadora (la usan el catálogo y otras páginas) */
try {
  window.OSCO_CALC_SKUS = [];
  Object.keys(PRODUCTS).forEach(function(k){
    var p = PRODUCTS[k]; if (p.hidden) return;
    if (p.sku && p.sku !== '—') window.OSCO_CALC_SKUS.push(String(p.sku));
    (p.presentations || []).forEach(function(x){ if (x.sku) window.OSCO_CALC_SKUS.push(String(x.sku)); });
  });
} catch (e) {}


/* =========================================================
   AJUSTES PARA LA WEB (voz pública, en "tú")
   ========================================================= */
function ajuste(k, campo, texto){ if (PARAM_DEFS[k]) PARAM_DEFS[k][campo] = texto; }
ajuste('volumen', 'label', 'Volumen de concreto');
ajuste('resistencia', 'label', 'Resistencia del concreto');
ajuste('fundasCemento', 'label', 'Fundas de cemento (50 kg) de tu mezcla');
ajuste('dosisMacrofibra', 'label', 'Dosis de macrofibra');
ajuste('dosisMacrofibra', 'hint', 'Referencia de ficha técnica: 2 a 5 kg/m³. La dosis exacta depende de tu losa (espesor, suelo y cargas) y la calcula sin costo el equipo técnico de Polyfibers.');
ajuste('areaLosa', 'label', 'Área de la losa o calle');
ajuste('area', 'label', 'Área total a tratar');
ajuste('pctDanos', 'label', '% del área con daños (huecos, grietas, desprendimientos)');
ajuste('pctDanos', 'hint', 'Si no tiene daños, pon 0.');
ajuste('espesorSelfing', 'label', 'Espesor del autonivelante Selfing 600');
ajuste('espesorSelfing', 'hint', 'Mínimo 3 mm y máximo 10 mm. Para piso industrial se recomienda 5 mm.');
ajuste('espesorEpoxSL800', 'label', 'Espesor del Epox SL 800');
ajuste('espesorEpoxSL800', 'hint', 'El espesor estándar es 1 mm.');
ajuste('longitudJunta', 'label', 'Largo total de las juntas');
ajuste('anchoJunta', 'label', 'Ancho de la junta');
ajuste('profundidadJunta', 'label', 'Profundidad de la junta');

/* Fibermix: producto Osco (1 bolsa de 2.2 kg por cada m³ de concreto) */
if (!PRODUCTS.fibermix) PRODUCTS.fibermix = {
  id: 'fibermix',
  name: 'Fibermix (Macrofibra + Microfibra) 2.2 kg',
  provider: 'Osco Dominicana',
  sku: '',
  match: 'fibermix',
  category: CATEGORIES.fibras ? CATEGORIES.fibras.name : 'Fibras de Refuerzo para Concreto',
  hasRange: false,
  unit: 'bolsas de 2.2 kg',
  params: ['volumen'],
  calc: function(inputs){
    var m3 = parseFloat(inputs.volumen || 0);
    return { m3: m3, units: ceilTo(m3) };
  },
  describeWeb: function(r){
    return 'Dosis fija: <b>1 bolsa por cada m³</b> de concreto. Para <b>' + fmt(r.m3, 1) + ' m³</b> necesitas <b>' + r.units + ' bolsas</b>.';
  }
};



/* ======== INICIO COMPLEMENTOS ========
   Qué se ofrece junto a cada producto. Se edita aquí: listas de SKU de la tienda.
   "para": productos donde aparece · "grupos": [título, SKU que se ofrecen]. */
var G = {
  lonasGranuladas: ['2028', '2029', '2031', '2043', '2053', '2049', '2075', '2077'],
  lonasLisas: ['2039', '2041', '2063', '2064', '2076'],
  primers: ['1011', '1012', '1103', '1014', '1015'],
  aluminio: ['3001', '5011'],
  cementoPlastico: ['3003', '3002'],
  techo: ['6001', '6002', '6004'],
  rolo: ['3015', '3014'],
  acrilicos: ['5001', '5015', '5012'],
  bituminosos: ['5005', '5006'],
  cementicios: ['7001', '7003', '7005', '7006'],
  backerRod: ['3017', '3018', '3019', '3020', '3025'],
  pisoEpoxico: ['1117', '9016', '1108', '8012', '8013'],
  concreto: ['9017', '9019', '9023', '9029', '9015'],
  curado: ['9010', '9012', '9014'],
  sotanos: ['6008', '6015', '6020', '6009', '6011'],
  morteros: ['1101', '1119', '1117', '8014', '8005']
};
var T = {
  imprimante: 'Antes de impermeabilizar: imprimante',
  remates: 'Para sellar uniones, bordes y remates',
  rolo: 'Herramientas para aplicarlo',
  techo: 'Para los desagües y la ventilación del techo',
  adherencia: 'Para mejorar la adherencia'
};
var COMPLEMENTOS = [
  { para: G.lonasLisas, grupos: [[T.imprimante, ['1011', '1012', '1103']], [T.remates, G.cementoPlastico], ['Protege tu lona lisa del sol', G.aluminio]] },
  { para: G.lonasGranuladas.concat(G.lonasLisas), grupos: [[T.imprimante, ['1011', '1012', '1103']], [T.remates, G.cementoPlastico], [T.rolo, G.rolo], [T.techo, G.techo]] },
  { para: G.primers, grupos: [[T.rolo, G.rolo], [T.remates, G.cementoPlastico], [T.techo, G.techo]] },
  { para: G.aluminio, grupos: [[T.rolo, G.rolo], [T.remates, G.cementoPlastico], [T.techo, G.techo]] },
  { para: G.cementoPlastico, grupos: [[T.imprimante, ['1011', '1103']], [T.techo, G.techo]] },
  { para: G.techo, grupos: [['Para sellar alrededor del desagüe', G.cementoPlastico], ['Impermeabiliza tu techo', ['2031', '2041', '5001']]] },
  { para: G.acrilicos, grupos: [['Antes de aplicar: primer acrílico', ['5016']], ['Refuerza esquinas, juntas y grietas', ['6012', '6021']], [T.rolo, G.rolo], [T.techo, G.techo]] },
  { para: ['5016'], grupos: [['Termina con tu impermeabilizante', G.acrilicos], [T.rolo, G.rolo]] },
  { para: ['1121'], grupos: [['Antes de aplicar: primer de poliuretano', ['1123']], ['Refuerzo para la membrana', ['6016']], ['Capa final de protección UV', ['3030']], [T.rolo, G.rolo], [T.techo, G.techo]] },
  { para: ['1123', '3030'], grupos: [['Completa el sistema de poliuretano', ['1121', '1123', '3030', '6016']], [T.rolo, G.rolo]] },
  { para: G.bituminosos, grupos: [[T.imprimante, ['1011', '1012']], ['Refuerzo para la membrana', ['6017', '6018']], [T.rolo, G.rolo], [T.techo, G.techo]] },
  { para: G.cementicios, grupos: [[T.adherencia, ['9011', '9016']], ['Para detener filtraciones activas', ['1107']], ['Refuerzo para esquinas y grietas', ['6017', '6018']]] },
  { para: ['8002'], grupos: [['Relleno de fondo de junta', G.backerRod], ['Pistola aplicadora', ['3009']]] },
  { para: G.backerRod.concat(['3021', '3022', '3023', '3024', '3026']), grupos: [['Sellador para la junta', ['8002', '8015']], ['Pistola aplicadora', ['3009', '3016']]] },
  { para: ['3009', '3016'], grupos: [['Sellador para la junta', ['8002']], ['Relleno de fondo de junta', G.backerRod]] },
  { para: ['8015'], grupos: [['Relleno de fondo de junta', G.backerRod], ['Para el piso', ['8012', '8013']]] },
  { para: G.pisoEpoxico, grupos: [['Completa el sistema de piso epóxico', G.pisoEpoxico], ['Para las juntas del piso', ['8015']]] },
  { para: G.concreto, grupos: [['Para tu concreto', G.concreto], ['Para curar el concreto', G.curado]] },
  { para: G.curado.concat(['1111']), grupos: [['Para tu concreto', ['9017', '9023', '1111']]] },
  { para: G.sotanos.concat(['6010', '6013']), grupos: [['Protección de sótanos y muros', G.sotanos], ['Impermeabilizante para el muro', ['7006', '7003']]] },
  { para: ['1117'], grupos: [[T.adherencia, ['9011', '9016']]] },
  { para: G.morteros.filter(function(s){ return s !== '1117'; }), grupos: [[T.adherencia, ['9011', '9016']], ['Para curar la reparación', ['9010']]] },
  { para: ['1107'], grupos: [['Después de tapar la fuga, impermeabiliza', ['7005', '7006']]] }
];
var COMP_MAX_GRUPO = 4, COMP_MAX_TOTAL = 14;
/* Nombre corto de cada grupo para las pestañas (si falta, se usa el título) */
var CHIP = {};
CHIP[T.imprimante] = 'Imprimante'; CHIP[T.remates] = 'Sellar remates'; CHIP[T.rolo] = 'Herramientas'; CHIP[T.techo] = 'Desagües y ventilación'; CHIP[T.adherencia] = 'Adherencia';
CHIP['Protege tu lona lisa del sol'] = 'Protección solar'; CHIP['Antes de aplicar: primer acrílico'] = 'Primer'; CHIP['Antes de aplicar: primer de poliuretano'] = 'Primer';
CHIP['Refuerza esquinas, juntas y grietas'] = 'Refuerzo'; CHIP['Refuerzo para la membrana'] = 'Refuerzo'; CHIP['Refuerzo para esquinas y grietas'] = 'Refuerzo';
CHIP['Capa final de protección UV'] = 'Protección UV'; CHIP['Relleno de fondo de junta'] = 'Backer rod'; CHIP['Pistola aplicadora'] = 'Pistola'; CHIP['Sellador para la junta'] = 'Sellador';
CHIP['Para detener filtraciones activas'] = 'Filtraciones activas'; CHIP['Para curar el concreto'] = 'Curado'; CHIP['Para curar la reparación'] = 'Curado'; CHIP['Para tu concreto'] = 'Concreto';
CHIP['Para sellar alrededor del desagüe'] = 'Sellar'; CHIP['Impermeabiliza tu techo'] = 'Impermeabilizantes'; CHIP['Completa el sistema de piso epóxico'] = 'Sistema epóxico'; CHIP['Para las juntas del piso'] = 'Juntas';
CHIP['Protección de sótanos y muros'] = 'Sótanos y muros'; CHIP['Impermeabilizante para el muro'] = 'Impermeabilizante'; CHIP['Termina con tu impermeabilizante'] = 'Impermeabilizante'; CHIP['Completa el sistema de poliuretano'] = 'Sistema'; CHIP['Para el piso'] = 'Piso epóxico';
CHIP['Después de tapar la fuga, impermeabiliza'] = 'Impermeabilizar';
/* ======== FIN COMPLEMENTOS ======== */

function complementosDe(skus, excluir){
  skus = skus.map(String); excluir = (excluir || []).concat(skus).map(String);
  var orden = [], porTitulo = {}, vistos = {};
  COMPLEMENTOS.forEach(function(regla){
    if (!regla.para.some(function(s){ return skus.indexOf(String(s)) !== -1; })) return;
    regla.grupos.forEach(function(g){
      if (!porTitulo[g[0]]){ porTitulo[g[0]] = []; orden.push(g[0]); }
      g[1].forEach(function(s){ s = String(s); if (excluir.indexOf(s) === -1 && porTitulo[g[0]].indexOf(s) === -1) porTitulo[g[0]].push(s); });
    });
  });
  var total = 0;
  return orden.map(function(t){
    var lista = porTitulo[t].filter(function(s){ return !vistos[s]; }).slice(0, COMP_MAX_GRUPO);
    lista = lista.slice(0, Math.max(0, COMP_MAX_TOTAL - total));
    lista.forEach(function(s){ vistos[s] = true; }); total += lista.length;
    return { titulo: t, skus: lista };
  }).filter(function(g){ return g.skus.length; });
}

var CATALOGO = null;
function catalogo(){
  if (CATALOGO) return CATALOGO;
  CATALOGO = fetch('/products.json?limit=250').then(function(r){ return r.ok ? r.json() : { products: [] }; }).then(function(d){
    var m = {};
    (d.products || []).forEach(function(sp){ (sp.variants || []).forEach(function(v){ if (v.sku) m[String(v.sku)] = { variantId: v.id, price: parseFloat(v.price), image: sp.images && sp.images[0] ? sp.images[0].src : '', url: '/products/' + sp.handle, title: sp.title }; }); });
    return m;
  }).catch(function(){ return {}; });
  return CATALOGO;
}

function cssComplementos(){
  if (document.getElementById('ocom-css')) return;
  var st = document.createElement('style'); st.id = 'ocom-css';
  st.textContent = '.ocom{margin:16px 0;padding:16px;border:1px solid #E3E7E9;border-left:4px solid #FF6900;border-radius:10px;background:#fff;font-family:inherit}' +
    '.ocom__h{margin:0;font-size:17px;font-weight:700;color:#091F2C!important;line-height:1.3}' +
    '.ocom__s{margin:2px 0 12px;font-size:13px;color:#5b6369!important;line-height:1.4}' +
    '.ocom__tabs{display:flex;gap:6px;overflow-x:auto;padding-bottom:4px;margin-bottom:10px;scrollbar-width:none}' +
    '.ocom__tabs::-webkit-scrollbar{display:none}' +
    '.ocom__t{flex:0 0 auto;font:inherit;font-size:13px;font-weight:600;border:1.5px solid #cfd6da;background:#fff;color:#091F2C;border-radius:999px;padding:6px 12px;cursor:pointer;white-space:nowrap;transition:background .2s,color .2s,border-color .2s}' +
    '.ocom__t.is-on{background:#091F2C;border-color:#091F2C;color:#fff}' +
    '.ocom__t span{display:inline-block;min-width:18px;margin-left:5px;padding:0 5px;border-radius:999px;background:#FF6900;color:#fff;font-size:11px}' +
    '.ocom__g{margin:0 0 8px;font-size:13px;font-weight:600;color:#285C4D!important}' +
    '.ocom__row{display:flex;gap:10px;overflow-x:auto;padding:2px 2px 6px;scroll-snap-type:x mandatory}' +
    '.ocom__row[hidden]{display:none}' +
    '.ocom__c{flex:0 0 132px;scroll-snap-align:start;display:flex;flex-direction:column;gap:5px;border:1px solid #E3E7E9;border-radius:8px;padding:8px;background:#fff;animation:ocomIn .3s both}' +
    '.ocom__c a.ocom__img{display:block;height:92px;background:#F5F5F5;border-radius:6px;overflow:hidden}' +
    '.ocom__c img{width:100%;height:100%;object-fit:contain}' +
    '.ocom__n{font-size:12.5px;line-height:1.3;color:#091F2C!important;text-decoration:none!important;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:33px}' +
    '.ocom__p{font-size:13px;font-weight:700;color:#091F2C!important}' +
    '.ocom__b{font:inherit;font-size:12.5px;font-weight:600;border:1.5px solid #FF6900;background:#fff;color:#FF6900!important;border-radius:5px;padding:6px;cursor:pointer;transition:background .2s,color .2s}' +
    '.ocom__b:hover{background:#FF6900;color:#fff!important}' +
    '.ocom__b.is-ok{background:#285C4D;border-color:#285C4D;color:#fff!important}' +
    '.ocom__toast{position:fixed;left:50%;bottom:24px;transform:translate(-50%,140%);opacity:0;visibility:hidden;background:#091F2C;color:#fff;padding:13px 18px;border-radius:8px;font-size:14.5px;z-index:99;transition:transform .3s,opacity .3s;box-shadow:0 10px 30px rgba(0,0,0,.25)}' +
    '.ocom__toast.is-on{transform:translate(-50%,0);opacity:1;visibility:visible}' +
    '.ocom__toast a{color:#FF6900!important;font-weight:700;margin-left:6px}' +
    '@keyframes ocomIn{from{opacity:0;transform:translateX(10px)}to{opacity:1;transform:none}}' +
    '@media(prefers-reduced-motion:reduce){.ocom__c{animation:none}}';
  document.head.appendChild(st);
}

function pintarComplementos(caja, skus, opts){
  opts = opts || {};
  if (!caja) return;
  var grupos = complementosDe(skus, opts.excluir);
  if (!grupos.length){ caja.hidden = true; caja.innerHTML = ''; return; }
  cssComplementos();
  catalogo().then(function(cat){
    var tabs = '', rows = '', k = 0;
    grupos.forEach(function(g){
      var n = 0;
      var cards = g.skus.filter(function(s){ return cat[s]; }).map(function(s){
        var p = cat[s], img = p.image ? p.image.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') : '';
        n++;
        return '<div class="ocom__c" style="animation-delay:' + (n * 50) + 'ms"><a class="ocom__img" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="132" height="92">' : '') + '</a><a class="ocom__n" href="' + p.url + '">' + p.title.replace(/[<>&]/g, '') + '</a><span class="ocom__p">RD$ ' + p.price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '</span><button type="button" class="ocom__b" data-ocom-add="' + p.variantId + '">Agregar</button></div>';
      }).join('');
      if (!cards) return;
      tabs += '<button type="button" class="ocom__t' + (k === 0 ? ' is-on' : '') + '" data-ocom-tab="' + k + '">' + (CHIP[g.titulo] || g.titulo) + '<span>' + n + '</span></button>';
      rows += '<div class="ocom__row" data-ocom-row="' + k + '"' + (k === 0 ? '' : ' hidden') + '><p class="ocom__g" style="flex:0 0 100%;display:none"></p>' + cards + '</div>';
      rows = rows.replace('<p class="ocom__g" style="flex:0 0 100%;display:none"></p>', '');
      k++;
    });
    if (!k){ caja.hidden = true; return; }
    var titulos = grupos.filter(function(g){ return g.skus.some(function(s){ return cat[s]; }); }).map(function(g){ return g.titulo; });
    caja.innerHTML = '<p class="ocom__h">' + (opts.titulo || 'Completa tu obra') + '</p><p class="ocom__s">' + (opts.sub || 'Lo que normalmente se lleva junto con este producto. Agrégalo a tu cotización con un toque.') + '</p><div class="ocom__tabs" role="tablist">' + tabs + '</div><p class="ocom__g" data-ocom-tit>' + titulos[0] + '</p>' + rows;
    Array.prototype.forEach.call(caja.querySelectorAll('[data-ocom-tab]'), function(t){
      t.addEventListener('click', function(){
        var i = t.getAttribute('data-ocom-tab');
        Array.prototype.forEach.call(caja.querySelectorAll('[data-ocom-tab]'), function(x){ x.classList.toggle('is-on', x === t); });
        Array.prototype.forEach.call(caja.querySelectorAll('[data-ocom-row]'), function(r){ r.hidden = r.getAttribute('data-ocom-row') !== i; });
        caja.querySelector('[data-ocom-tit]').textContent = titulos[+i];
      });
    });
    caja.hidden = false;
    Array.prototype.forEach.call(caja.querySelectorAll('[data-ocom-add]'), function(b){
      b.addEventListener('click', function(){
        b.disabled = true; b.textContent = 'Agregando…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-ocom-add'), quantity: 1 }] }) })
          .then(function(r){ if (!r.ok) throw r; return fetch('/cart.js'); }).then(function(r){ return r.json(); })
          .then(function(c){
            b.classList.add('is-ok'); b.textContent = 'Agregado ✓';
            Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span'), function(el){ el.textContent = c.item_count; });
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            avisoComp('Agregado a tu cotización. <a href="/cart">Ver mi cotización</a>');
          })
          .catch(function(){ b.textContent = 'Intenta de nuevo'; })
          .then(function(){ setTimeout(function(){ b.disabled = false; if (b.classList.contains('is-ok')){ b.classList.remove('is-ok'); b.textContent = 'Agregar otro'; } }, 2500); });
      });
    });
  });
}
function avisoComp(html){
  var t = document.getElementById('ocom-toast');
  if (!t){ t = document.createElement('div'); t.id = 'ocom-toast'; t.className = 'ocom__toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
  t.innerHTML = html; t.classList.add('is-on');
  clearTimeout(avisoComp.t); avisoComp.t = setTimeout(function(){ t.classList.remove('is-on'); }, 4500);
}

/* Página de producto: bloque "Completa tu obra" */
function iniciarComplementos(){
  var caja = document.getElementById('ocom');
  if (!caja || caja.getAttribute('data-listo')) return;
  caja.setAttribute('data-listo', '1');
  var sku = caja.getAttribute('data-sku');
  if (sku) pintarComplementos(caja, [sku]);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarComplementos); else iniciarComplementos();

/* =========================================================
   BOTÓN EN LA PÁGINA DE PRODUCTO
   Aparece solo si el producto está en la calculadora.
   ========================================================= */
function iniciarBoton(){
  var cta = document.getElementById('ocal-cta');
  if (!cta || cta.getAttribute('data-listo')) return;
  cta.setAttribute('data-listo', '1');
  var sku = cta.getAttribute('data-sku') || '', handle = cta.getAttribute('data-handle') || '';
  var base = cta.getAttribute('data-url') || '/pages/calculadora', hit = null;
  Object.keys(PRODUCTS).some(function(k){
    var p = PRODUCTS[k];
    if (p.hidden) return false;
    if ((skuValido(p) && sku && String(p.sku) === String(sku)) || (sku && presPorSku(p, sku) != null) || (!skuValido(p) && !p.presentations && clave(p) && handle.indexOf(clave(p)) !== -1)){ hit = p; return true; }
    return false;
  });
  if (!hit) return;
  var a = cta.querySelector('a');
  var pPi = presPorSku(hit, sku);
  if (a) a.href = base + (pPi != null ? '?sku=' + encodeURIComponent(sku) : (skuValido(hit) ? '?sku=' + encodeURIComponent(hit.sku) : '?p=' + encodeURIComponent(hit.id)));
  cta.hidden = false;
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciarBoton); else iniciarBoton();

/* =========================================================
   INTERFAZ
   ========================================================= */
var root = document.getElementById('ocal');
if (!root) return;
var WA = root.getAttribute('data-wa') || '18498598576';
var $ = function(s, el){ return (el || root).querySelector(s); };
var $$ = function(s, el){ return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
var esc = function(t){ return String(t).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); };

function skuValido(p){ return p.sku && p.sku !== '—'; }
function clave(p){
  if (p.match) return p.match;
  return p.name.split(' (')[0].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}
function uf(p, n, pi){
  if (p.presentations && pi != null && typeof unitWord === 'function') return unitWord(p.presentations[pi].unit, n == null ? 0 : n);
  return (typeof unitFor === 'function' && n != null) ? unitFor(p, n, pi) : p.unit;
}
function norm(t){ return String(t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); }
function pajar(p){
  return norm([p.name, p.sku, p.category, p.provider].concat((p.presentations || []).map(function(x){ return x.sku + ' ' + x.name + ' ' + x.label; }), p.keywords || []).join(' '));
}
function presDesdeTexto(p, q){
  if (!p.presentations || !q) return null;
  var t = norm(q).split(/\s+/).filter(Boolean);
  var hits = [];
  p.presentations.forEach(function(x, i){ var h = norm(x.sku + ' ' + x.name + ' ' + x.label); if (t.every(function(k){ return h.indexOf(k) !== -1; })) hits.push(i); });
  return hits.length === 1 ? hits[0] : null;
}
function presPorSku(p, sku){
  if (!p.presentations) return null;
  for (var i = 0; i < p.presentations.length; i++) if (String(p.presentations[i].sku) === String(sku)) return i;
  return null;
}
function buscarSku(sku){
  var out = null;
  Object.keys(PRODUCTS).some(function(k){
    var p = PRODUCTS[k];
    if (p.hidden) return false;
    if (skuValido(p) && String(p.sku) === String(sku)){ out = { id: k, pi: presPorSku(p, sku) }; return true; }
    var pi = presPorSku(p, sku);
    if (pi != null){ out = { id: k, pi: pi }; return true; }
    return false;
  });
  return out;
}
function presIni(p){ return p.presentations ? (p.defaultPres || 0) : null; }
function tienda(p, pi){ return (p.presentations && pi != null && p._shop) ? p._shop[pi] : SHOP[p.id]; }
function notaPres(p, pi){
  if (!p.presentations || pi == null) return '';
  var x = p.presentations[pi];
  if (x.roll && x.roll !== 10) return 'Rollo de ' + x.roll + ' m: rinde ' + fmt(x.size, 1) + ' m² útiles.';
  return p.sameCalcNote || '';
}
var state = { tab: 'producto', pid: null, modeIdx: 0, presIdx: null, slider: null, sysIds: [], sysName: '', sysOwn: false, sysMode: {}, sysPres: {} };
var IMGS = {};
try { IMGS = JSON.parse(root.getAttribute('data-imagenes') || '{}'); } catch (e) {}
var SHOP = {}; // id -> {variantId, price, image, url, title}

/* ---------- Productos de la tienda (foto, precio y enlace) ---------- */
function cargarTienda(){
  return fetch('/products.json?limit=250').then(function(r){ return r.ok ? r.json() : { products: [] }; })
    .then(function(d){
      var list = d.products || [], porSku = {};
      list.forEach(function(sp){ (sp.variants || []).forEach(function(v){ if (v.sku) porSku[String(v.sku)] = { variantId: v.id, price: parseFloat(v.price), image: sp.images && sp.images[0] ? sp.images[0].src : '', url: '/products/' + sp.handle, title: sp.title }; }); });
      Object.keys(PRODUCTS).forEach(function(k){
        var p = PRODUCTS[k];
        if (!p.presentations) return;
        p._shop = p.presentations.map(function(x){
          var s = porSku[String(x.sku)] || null;
          if (s && s.price > 0) x.price = s.price;
          return s;
        });
        var first = p._shop[presIni(p)] || p._shop.filter(Boolean)[0];
        if (first) SHOP[k] = first;
      });
      Object.keys(PRODUCTS).forEach(function(id){
        if (PRODUCTS[id].presentations) return;
        var p = PRODUCTS[id], hit = null, variant = null;
        list.some(function(sp){
          var v = (sp.variants || []).filter(function(x){ return skuValido(p) && String(x.sku) === String(p.sku); })[0];
          if (v){ hit = sp; variant = v; return true; }
          return false;
        });
        if (!hit){
          var k = clave(p);
          list.some(function(sp){
            if (k && sp.handle.indexOf(k) !== -1){ hit = sp; variant = sp.variants[0]; return true; }
            return false;
          });
        }
        if (hit && variant){
          SHOP[id] = { variantId: variant.id, price: parseFloat(variant.price), image: hit.images && hit.images[0] ? hit.images[0].src : '', url: '/products/' + hit.handle, title: hit.title };
        }
      });
    }).catch(function(){});
}

/* ---------- Cálculo normalizado ---------- */
function calcular(p, modeIdx, inputs, sliderVal, pi){
  var out = { units: 0, unit: p.unit, detail: '', note: '', range: null, reco: null };
  if (p.presentations){ pi = pi == null ? presIni(p) : pi; inputs = Object.assign({}, inputs, { _pkg: p.presentations[pi].size, _pres: p.presentations[pi] }); }
  if (p.hasRange){
    var g = p.range, sel = sliderVal != null ? sliderVal : g.prom, dec = g.step < 0.1 ? 2 : 1;
    var rs = p.calcAt(inputs, sel), rmin = p.calcAt(inputs, g.min), rmax = p.calcAt(inputs, g.max);
    out.units = rs.units;
    out.unit = uf(p, rs.units);
    out.range = { min: rmin.units, max: rmax.units, sel: sel, g: g, dec: dec };
    var ctx = p.contextRow ? p.contextRow(inputs) : null;
    out.detail = (ctx ? ctx.label + ': <b>' + ctx.value + '</b>. ' : '') + g.readoutLabel + ': <b>' + sel.toFixed(dec) + g.unit + '</b>, equivale a <b>' + fmt(rs.amount, 1) + ' ' + g.amountUnit + '</b> de producto.';
    out.note = g.hint;
    return out;
  }
  var r = getProductCalc(p, modeIdx)(inputs);
  if (p.presentations) r.unitNet = unitWord(p.presentations[pi].unit, r.netUnits != null ? r.netUnits : 0);
  out.units = r.units;
  out.unit = uf(p, r.units, pi);
  if (p.modes){
    var m = p.modes[modeIdx || 0];
    out.detail = m.describe(r);
    var rango = r.unitsRefMin === r.unitsRefMax ? r.unitsRefMin : r.unitsRefMin + ' a ' + r.unitsRefMax;
    out.note = (m.footnote || '').replace('{min}', r.unitsRefMin).replace('{max}', r.unitsRefMax).replace('{sbr}', r.sbrCubetas).replace('{rango}', rango);
    if (r.units != null && p.presentations && !p.noReco && typeof recomendar === 'function'){ try { out.reco = recomendar(p, m, inputs, pi); } catch (e) {} }
    if (r.units == null){ out.blocked = true; out.units = null; out.unit = m.blockLabel || 'requiere diseño del ingeniero'; out.blockMsg = m.blockMsg || ''; }
  } else if (p.describeWeb){
    out.detail = p.describeWeb(r);
  } else if (p.marginPct != null){
    out.detail = 'Necesitas <b>' + fmt(r.kg, 1) + ' kg</b> de producto (' + r.netUnits + ' ' + p.unit + '). Te sugerimos <b>' + r.units + '</b>: incluye ' + Math.round(p.marginPct * 100) + '% extra para mermas, bordes y esquinas.';
  } else if (p.dosis){
    out.detail = 'Dosis de referencia: <b>' + p.dosis + ' kg/m³</b>, equivale a <b>' + fmt(r.kg, 1) + ' kg</b> de producto.';
    out.note = 'Si el ingeniero de tu obra indica otra dosis, escríbenos y lo ajustamos.';
  } else if (r.galones != null){
    out.detail = 'Volumen de las juntas: <b>' + fmt(r.volumenL, 2) + ' litros</b> (' + fmt(r.galones, 2) + ' galones).';
  }
  return out;
}

/* ---------- Campos ---------- */
function campo(key, pref){
  var d = PARAM_DEFS[key], id = pref + '-' + key;
  if (d.type === 'select'){
    var ops = d.options.map(function(o){ return '<option value="' + o.value + '"' + (String(o.value) === String(d.default) ? ' selected' : '') + '>' + o.label + '</option>'; }).join('');
    var mix = key === 'resistencia' ? '<label class="ocal-check"><input type="checkbox" data-param="usarCementoPropio" data-mix> <span>Conozco la dosificación de mi mezcla</span></label><div class="ocal-mix" hidden><div class="ocal-unit"><input type="number" min="0" step="1" placeholder="Ej.: 450" data-param="cementoPropio"><span>kg de cemento por m³</span></div></div><p class="ocal-hint">Si no la conoces, usamos una tabla estándar de referencia según la resistencia.</p>' : '';
    return '<div class="ocal-field"><label for="' + id + '">' + d.label + '</label><select id="' + id + '" data-param="' + key + '">' + ops + '</select>' + mix + '</div>';
  }
  return '<div class="ocal-field"><label for="' + id + '">' + d.label + '</label><div class="ocal-unit"><input type="number" inputmode="decimal" id="' + id + '" min="0" step="any" value="' + d.default + '" data-param="' + key + '"><span>' + d.suffix + '</span></div>' + (d.hint ? '<p class="ocal-hint">' + d.hint + '</p>' : '') + '</div>';
}
function leer(scope){
  var o = {};
  $$('[data-param]', scope).forEach(function(el){ o[el.getAttribute('data-param')] = el.type === 'checkbox' ? el.checked : el.value; });
  return o;
}
function enlazar(scope, fn){
  $$('[data-param]', scope).forEach(function(el){ el.addEventListener('input', fn); el.addEventListener('change', fn); });
  $$('[data-mix]', scope).forEach(function(cb){
    cb.addEventListener('change', function(){
      var f = cb.closest('.ocal-field');
      f.querySelector('.ocal-mix').hidden = !cb.checked;
      f.querySelector('select').disabled = cb.checked;
      if (cb.checked) f.querySelector('.ocal-mix input').focus();
    });
  });
}

/* ---------- Número animado ---------- */
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function contar(el, to){
  if (to == null){ el.textContent = '—'; el.setAttribute('data-v', 0); return; }
  var from = parseFloat(el.getAttribute('data-v') || 0);
  el.setAttribute('data-v', to);
  if (reduce || from === to){ el.textContent = to; return; }
  var t0 = null, dur = 450;
  function step(t){
    if (!t0) t0 = t;
    var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
    el.textContent = Math.round(from + (to - from) * e);
    if (k !== 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
  el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop');
}

/* ---------- Pestañas ---------- */
function pestaña(t){
  state.tab = t;
  $$('[data-tab]').forEach(function(b){ var on = b.getAttribute('data-tab') === t; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); });
  $('#ocal-producto').hidden = t !== 'producto';
  $('#ocal-sistema').hidden = t !== 'sistema';
}
$$('[data-tab]').forEach(function(b){ b.addEventListener('click', function(){ pestaña(b.getAttribute('data-tab')); }); });

/* ---------- Lista de productos ---------- */
function ordenados(q){
  q = (q || '').toLowerCase();
  var orden = Object.keys(CATEGORIES).map(function(k){ return CATEGORIES[k].name; });
  return Object.keys(PRODUCTS).map(function(k){ return PRODUCTS[k]; })
    .filter(function(p){ if (p.hidden) return false; if (!q.trim()) return true; var h = pajar(p); return norm(q).split(/\s+/).filter(Boolean).every(function(t){ return h.indexOf(t) !== -1; }); })
    .sort(function(a, b){ return orden.indexOf(a.category) - orden.indexOf(b.category); });
}
function foto(id){
  if (IMGS[id]) return '<img src="' + IMGS[id] + '" alt="" loading="lazy" width="200" height="200">';
  var s = SHOP[id];
  return s && s.image ? '<img src="' + s.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" loading="lazy" width="200" height="200">' : '<span class="ocal-noimg" aria-hidden="true"></span>';
}
function pintarLista(){
  var q = $('#ocal-buscar').value;
  var items = ordenados(q);
  $('#ocal-lista').innerHTML = items.length ? items.map(function(p){
    return '<button type="button" class="ocal-pcard' + (state.pid === p.id ? ' is-on' : '') + '" data-pid="' + p.id + '">' + foto(p.id) + '<span class="ocal-pcard__t"><b>' + esc(p.name) + '</b><small>' + (p.presentations && p.presentations.length > 2 ? p.presentations.length + ' referencias, un solo cálculo' : esc(p.category)) + '</small></span></button>';
  }).join('') : '<p class="ocal-empty">No encontramos ese producto en la calculadora. Escríbenos y te ayudamos a calcularlo.</p>';
  $$('[data-pid]').forEach(function(b){ b.addEventListener('click', function(){ var id = b.getAttribute('data-pid'); elegir(id, true, presDesdeTexto(PRODUCTS[id], $('#ocal-buscar').value)); }); });
}
$('#ocal-buscar').addEventListener('input', pintarLista);

function elegir(id, scroll, pi){
  if (!PRODUCTS[id]) return;
  state.pid = id; state.modeIdx = 0; state.slider = null;
  state.presIdx = PRODUCTS[id].presentations ? (pi != null ? pi : presIni(PRODUCTS[id])) : null;
  pestaña('producto');
  root.classList.add('has-product');
  pintarChip();
  formulario();
  pintarLista();
  if (scroll){ var t = $('#ocal-paso2'); if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
}

function pintarChip(){
  var id = state.pid, p = PRODUCTS[id], s = tienda(p, state.presIdx), np = notaPres(p, state.presIdx);
  $('#ocal-elegido').innerHTML = foto(id) + '<div><b>' + esc(p.name) + '</b><small>' + esc(p.category) + ' · respaldado por ' + esc(p.provider) + '</small>' + (np ? '<small class="ocal-same">' + esc(np) + '</small>' : '') + (s ? '<a href="' + s.url + '">Ver producto y ficha técnica</a>' : '') + '</div><button type="button" class="ocal-link" id="ocal-cambiar">Cambiar</button>';
  $('#ocal-cambiar').addEventListener('click', function(){ root.classList.remove('has-product'); $('#ocal-buscar').focus(); });
  var skuAct = p.presentations && state.presIdx != null ? p.presentations[state.presIdx].sku : p.sku;
  if (skuAct && skuAct !== '—') pintarComplementos($('#ocal-comp'), [skuAct], { sub: 'Lo que normalmente se lleva junto con este producto. Agrégalo a tu cotización con un toque.' });
  else $('#ocal-comp').hidden = true;
}
function formulario(){
  var p = PRODUCTS[state.pid];
  var tituloModo = p.modeTitle === 'Uso' ? '¿Para qué lo vas a usar?' : '¿Cómo quieres calcularlo?';
  var modos = p.modes && p.modes.length > 1 ? '<div class="ocal-field"><label>' + tituloModo + '</label><div class="ocal-pills ocal-pills--uso">' + p.modes.map(function(m, i){ return '<button type="button" class="ocal-pill' + (i === state.modeIdx ? ' is-on' : '') + '" data-modo="' + i + '">' + m.label + '</button>'; }).join('') + '</div></div>' : '';
  var rango = '';
  if (p.hasRange){
    var g = p.range, dec = g.step < 0.1 ? 2 : 1;
    rango = '<div class="ocal-field"><label for="ocal-slider">' + g.label + '</label><div class="ocal-slider"><input type="range" id="ocal-slider" min="' + g.min + '" max="' + g.max + '" step="' + g.step + '" value="' + (state.slider != null ? state.slider : g.prom) + '"><div class="ocal-slider__marks"><span>' + g.min.toFixed(dec) + '</span><span>' + g.prom.toFixed(dec) + ' recomendado</span><span>' + g.max.toFixed(dec) + '</span></div></div><p class="ocal-hint">' + g.hint + '</p></div>';
  }
  var pres = '';
  if (p.presentations && p.presentations.length > 1){
    var lab = p.presLabel || 'Presentación';
    pres = '<div class="ocal-field"><label for="ocal-pres">' + (lab === 'Referencia' ? '¿Cuál vas a usar?' : '¿Qué presentación prefieres?') + '</label>' +
      (p.presentations.length > 4
        ? '<select id="ocal-pres">' + p.presentations.map(function(x, i){ return '<option value="' + i + '"' + (i === state.presIdx ? ' selected' : '') + '>' + esc(x.label) + '</option>'; }).join('') + '</select>'
        : '<div class="ocal-pills">' + p.presentations.map(function(x, i){ return '<button type="button" class="ocal-pill' + (i === state.presIdx ? ' is-on' : '') + '" data-pres="' + i + '">' + esc(x.label) + '</button>'; }).join('') + '</div>') + '</div>';
  }
  $('#ocal-campos').innerHTML = pres + modos + getProductParams(p, state.modeIdx).map(function(k){ return campo(k, 'u'); }).join('') + rango;
  enlazar($('#ocal-campos'), recalcular);
  $$('[data-modo]').forEach(function(b){ b.addEventListener('click', function(){ state.modeIdx = +b.getAttribute('data-modo'); formulario(); }); });
  var ps = $('#ocal-pres');
  if (ps) ps.addEventListener('change', function(){ state.presIdx = +ps.value; pintarChip(); recalcular(); });
  $$('[data-pres]').forEach(function(b){ b.addEventListener('click', function(){ state.presIdx = +b.getAttribute('data-pres'); $$('[data-pres]').forEach(function(x){ x.classList.toggle('is-on', x === b); }); pintarChip(); recalcular(); }); });
  var sl = $('#ocal-slider');
  if (sl) sl.addEventListener('input', function(){ state.slider = parseFloat(sl.value); recalcular(); });
  recalcular();
}

/* ---------- Resultado de un producto ---------- */
var ultimo = null;
function recalcular(){
  var p = PRODUCTS[state.pid]; if (!p) return;
  var inp = leer($('#ocal-campos'));
  var r = calcular(p, state.modeIdx, inp, state.slider, state.presIdx);
  ultimo = { p: p, r: r };
  contar($('#ocal-num'), r.units);
  contar($('#ocal-mini-num'), r.units);
  $('#ocal-unidad').textContent = r.unit;
  $('#ocal-mini-unidad').textContent = r.unit;
  $('#ocal-detalle').innerHTML = r.detail;
  $('#ocal-nota').innerHTML = r.note || 'Redondeamos siempre hacia arriba al empaque completo.';
  var rg = $('#ocal-rango');
  if (r.range){
    rg.hidden = false;
    var g = r.range.g, pos = (r.range.sel - g.min) / (g.max - g.min) * 100;
    rg.innerHTML = '<div class="ocal-bar"><span style="left:' + pos + '%"></span></div><div class="ocal-bar__l"><span>Mínimo<b>' + r.range.min + '</b></span><span>Tu selección<b>' + r.units + '</b></span><span>Máximo<b>' + r.range.max + '</b></span></div>';
  } else rg.hidden = true;
  var s = tienda(p, state.presIdx);
  $('#ocal-reco').innerHTML = recoWeb(r.reco, state.presIdx);
  var add = $('#ocal-agregar');
  add.disabled = !s || !r.units;
  add.textContent = s && r.units ? 'Agregar ' + r.units + ' a mi cotización' : 'Agregar a mi cotización';
  if (r.blocked) $('#ocal-detalle').innerHTML = r.detail + (r.blockMsg ? '<br><b>' + r.blockMsg + '</b>' : '');
  $('#ocal-precio').innerHTML = s && s.price && r.units ? 'Precio de referencia: <b>RD$ ' + fmt(s.price * r.units, 2) + '</b> (' + r.units + ' × RD$ ' + fmt(s.price, 2) + ')' : '';
  $('#ocal-wa').href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent(r.blocked
    ? 'Hola, usé la calculadora de la web de Osco. Necesito ayuda con la dosis de ' + p.name + ' para mi obra.'
    : 'Hola, usé la calculadora de la web de Osco. Me salió que necesito ' + r.units + ' ' + r.unit + ' de ' + p.name + '. ¿Me ayudan a confirmarlo y cotizarlo?');
}

/* ---------- Presentación más económica ---------- */
function recoWeb(rec, pi){
  if (!rec || !rec.combo) return '';
  var selCost = rec.sel.cost, diff = selCost != null ? selCost - rec.combo.cost : null;
  var mismo = rec.combo.items.length === 1 && rec.combo.items[0].p === rec.sel.p;
  if (mismo || (diff != null && diff <= 0.005)) return '<p class="ocal-reco ocal-reco--ok">Esta presentación ya es la más económica para esa cantidad.</p>';
  return '<p class="ocal-reco"><b>Te sale más económico:</b> ' + comboText(rec.combo) + ' por ' + money(rec.combo.cost) + (diff != null ? ', ahorras <b>' + money(diff) + '</b>' : '') + '.</p>';
}

/* ---------- Agregar a la cotización ---------- */
function agregar(items, btn){
  items = items.filter(function(i){ return i.id && i.quantity; });
  if (!items.length) return;
  var txt = btn.textContent; btn.disabled = true; btn.textContent = 'Agregando…';
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
    .then(function(r){ if (!r.ok) throw r; return fetch('/cart.js'); })
    .then(function(r){ return r.json(); })
    .then(function(c){
      $$('[data-cart-count], .cart-count, .cart-count-bubble span').forEach(function(el){ el.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      aviso('Agregado a tu cotización. <a href="/cart">Ver mi cotización</a>');
    })
    .catch(function(){ aviso('No pudimos agregarlo. Escríbenos por WhatsApp y te lo cotizamos.'); })
    .then(function(){ btn.disabled = false; btn.textContent = txt; });
}
function aviso(html){
  var t = $('#ocal-toast'); t.innerHTML = html; t.classList.add('is-on');
  clearTimeout(aviso.t); aviso.t = setTimeout(function(){ t.classList.remove('is-on'); }, 5000);
}
$('#ocal-agregar').addEventListener('click', function(){
  if (!ultimo) return;
  var s = tienda(ultimo.p, state.presIdx);
  if (s) agregar([{ id: s.variantId, quantity: ultimo.r.units }], this);
});

/* ---------- Sistemas ---------- */
function pintarSistemas(){
  var html = Object.keys(SYSTEMS).map(function(k){
    var s = SYSTEMS[k];
    return '<button type="button" class="ocal-sys" data-sys="' + k + '"><span class="ocal-sys__tag">Sistema recomendado</span><b>' + esc(s.name) + '</b><small>' + (s.description ? esc(s.description).replace(/ · /g, ' + ') : s.productIds.map(function(i){ return esc(PRODUCTS[i].name.split(' (')[0]); }).join(' + ')) + '</small></button>';
  }).join('');
  html += '<button type="button" class="ocal-sys ocal-sys--own" data-sys="__propio"><span class="ocal-sys__tag">A tu medida</span><b>Arma tu combinación</b><small>Elige los productos de tu obra y llena los datos una sola vez.</small></button>';
  $('#ocal-sistemas').innerHTML = html;
  $$('[data-sys]').forEach(function(b){ b.addEventListener('click', function(){ sistema(b.getAttribute('data-sys')); }); });
}
function sistema(k){
  $$('[data-sys]').forEach(function(b){ b.classList.toggle('is-on', b.getAttribute('data-sys') === k); });
  var own = k === '__propio';
  $('#ocal-propio').hidden = !own;
  state.sysOwn = own; state.sysMode = {}; state.sysPres = {};
  if (own){ state.sysIds = []; state.sysName = 'Tu combinación'; pintarPropio(); }
  else { state.sysIds = SYSTEMS[k].productIds.slice(); state.sysName = SYSTEMS[k].name; }
  camposSistema();
}
function pintarPropio(){
  $('#ocal-propio-lista').innerHTML = ordenados('').map(function(p){
    var on = state.sysIds.indexOf(p.id) !== -1;
    return '<label class="ocal-chk' + (on ? ' is-on' : '') + '"><input type="checkbox" value="' + p.id + '"' + (on ? ' checked' : '') + '><span>' + esc(p.name) + '</span></label>';
  }).join('');
  $$('#ocal-propio-lista input').forEach(function(cb){
    cb.addEventListener('change', function(){
      cb.parentNode.classList.toggle('is-on', cb.checked);
      if (cb.checked) state.sysIds.push(cb.value); else state.sysIds = state.sysIds.filter(function(i){ return i !== cb.value; });
      camposSistema();
    });
  });
}
function camposSistema(){
  var box = $('#ocal-sis-trabajo');
  if (!state.sysIds.length){ box.hidden = true; return; }
  box.hidden = false;
  var prev = leer($('#ocal-sis-campos'));
  var need = [], usos = '';
  state.sysIds.forEach(function(i){
    var p = PRODUCTS[i], mi = state.sysMode[i] || 0;
    if (p.presentations && p.presentations.length > 1){
      var pv = state.sysPres[i] != null ? state.sysPres[i] : presIni(p);
      usos += '<div class="ocal-field"><label>' + (p.presLabel === 'Referencia' ? 'Referencia de ' : 'Presentación de ') + esc(p.name.split(' (')[0]) + '</label><select data-syspres="' + i + '">' + p.presentations.map(function(x, n){ return '<option value="' + n + '"' + (n === pv ? ' selected' : '') + '>' + esc(x.label) + '</option>'; }).join('') + '</select></div>';
    }
    if (state.sysOwn && p.modes && p.modes.length > 1){
      usos += '<div class="ocal-field"><label>Uso de ' + esc(p.name.split(' (')[0]) + '</label><select data-sysmode="' + i + '">' + p.modes.map(function(m, n){ return '<option value="' + n + '"' + (n === mi ? ' selected' : '') + '>' + esc(m.label) + '</option>'; }).join('') + '</select></div>';
    }
    getProductParams(p, mi).forEach(function(k){ if (need.indexOf(k) === -1) need.push(k); });
  });
  $('#ocal-sis-campos').innerHTML = usos + need.map(function(k){ return campo(k, 's'); }).join('');
  $$('#ocal-sis-campos [data-param]').forEach(function(el){
    var k = el.getAttribute('data-param');
    if (prev[k] == null) return;
    if (el.type === 'checkbox') el.checked = prev[k] === true; else el.value = prev[k];
  });
  $$('[data-syspres]').forEach(function(sel){ sel.addEventListener('change', function(){ state.sysPres[sel.getAttribute('data-syspres')] = +sel.value; recalcSistema(); }); });
  $$('[data-sysmode]').forEach(function(sel){ sel.addEventListener('change', function(){ state.sysMode[sel.getAttribute('data-sysmode')] = +sel.value; camposSistema(); }); });
  enlazar($('#ocal-sis-campos'), recalcSistema);
  recalcSistema();
}
var ultimoSis = [];
function recalcSistema(){
  var inp = leer($('#ocal-sis-campos'));
  var total = 0, conPrecio = true;
  ultimoSis = state.sysIds.map(function(i){ var p = PRODUCTS[i], pi = p.presentations ? (state.sysPres[i] != null ? state.sysPres[i] : presIni(p)) : null; return { p: p, pi: pi, r: calcular(p, state.sysMode[i] || 0, inp, null, pi) }; });
  $('#ocal-sis-res').innerHTML = ultimoSis.map(function(x, n){
    var s = tienda(x.p, x.pi);
    if (s && s.price && x.r.units) total += s.price * x.r.units; else if (!x.r.blocked) conPrecio = false;
    var rg = x.r.range ? '<small class="ocal-row__rg">Rango según la superficie: ' + x.r.range.min + ' a ' + x.r.range.max + '</small>' : '';
    return '<div class="ocal-row" style="animation-delay:' + (n * 60) + 'ms">' + foto(x.p.id) + '<div class="ocal-row__t"><b>' + esc(x.pi != null ? x.p.presentations[x.pi].name : x.p.name) + '</b><small>' + x.r.detail + '</small>' + rg + (x.r.blocked && x.r.blockMsg ? '<small class="ocal-row__rg">' + x.r.blockMsg + '</small>' : '') + '</div><div class="ocal-row__q"><b>' + (x.r.units == null ? '—' : x.r.units) + '</b><small>' + esc(x.r.unit) + '</small></div></div>';
  }).join('');
  var skusSis = ultimoSis.map(function(x){ return x.pi != null ? x.p.presentations[x.pi].sku : x.p.sku; }).filter(function(k){ return k && k !== '—'; });
  if (skusSis.join() !== recalcSistema.ult){ recalcSistema.ult = skusSis.join(); pintarComplementos($('#ocal-sis-comp'), skusSis, { excluir: [].concat.apply([], ultimoSis.map(function(x){ return x.p.presentations ? x.p.presentations.map(function(y){ return y.sku; }) : [x.p.sku]; })), titulo: 'Completa tu sistema', sub: 'Herramientas y accesorios que normalmente se llevan con este sistema.' }); }
  $('#ocal-sis-total').innerHTML = conPrecio && total ? 'Total de referencia del sistema: <b>RD$ ' + fmt(total, 2) + '</b> (materiales, sin mano de obra)' : '';
  var add = $('#ocal-sis-agregar');
  add.disabled = !ultimoSis.some(function(x){ return tienda(x.p, x.pi) && x.r.units; });
  var linea = ultimoSis.map(function(x){ return '- ' + (x.r.units == null ? 'dosis por confirmar' : x.r.units + ' ' + x.r.unit) + ' de ' + x.p.name; }).join('\n');
  $('#ocal-sis-wa').href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent('Hola, usé la calculadora de la web de Osco para un ' + state.sysName + '. Me salió:\n' + linea + '\n¿Me ayudan a confirmarlo y cotizarlo?');
}
$('#ocal-sis-agregar').addEventListener('click', function(){
  agregar(ultimoSis.filter(function(x){ return tienda(x.p, x.pi) && x.r.units; }).map(function(x){ return { id: tienda(x.p, x.pi).variantId, quantity: x.r.units }; }), this);
});

/* ---------- Barra fija del celular ---------- */
$('#ocal-mini').addEventListener('click', function(){ $('#ocal-resultado').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); });
if ('IntersectionObserver' in window){
  new IntersectionObserver(function(en){ root.classList.toggle('res-visible', en[0].isIntersecting); }).observe($('#ocal-resultado'));
}

/* ---------- Inicio y enlaces directos (?sku=9019, ?p=macrofibra, ?sistema=piso_epoxico_baumerk) ---------- */
function inicio(){
  pintarLista(); pintarSistemas();
  var q = new URLSearchParams(location.search), id = q.get('p'), sku = q.get('sku'), sis = q.get('sistema');
  var pi0 = null;
  if (sku){ var f = buscarSku(sku); if (f){ id = f.id; pi0 = f.pi; } }
  if (sis && SYSTEMS[sis]){ pestaña('sistema'); sistema(sis); }
  else if (id && PRODUCTS[id]) elegir(id, false, pi0);
}
inicio();
cargarTienda().then(function(){ pintarLista(); if (state.pid){ pintarChip(); recalcular(); } if (state.sysIds.length) recalcSistema(); });

})();